/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-9ecdf98c.js';
import React from 'react';
import '@carbon/icon-helpers';
import 'prop-types';

var _circle, _path, _path2, _circle2, _path3, _path4, _circle3, _path5, _path6, _circle4, _path7, _circle5, _path8, _circle6, _path9, _circle7, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _switch, _switch2, _switch3, _switch4, _circle8, _circle9, _circle10, _circle11, _path43, _path44, _circle12, _circle13, _circle14, _circle15, _path45, _path46, _circle16, _circle17, _circle18, _circle19, _path47, _path48, _circle20, _circle21, _circle22, _circle23, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _circle24, _circle25, _circle26, _path144, _path145, _circle27, _circle28, _circle29, _path146, _path147, _circle30, _circle31, _circle32, _path148, _path149, _circle33, _circle34, _circle35, _path150, _path151, _circle36, _circle37, _path152, _circle38, _path153, _path154, _circle39, _circle40, _path155, _circle41, _path156, _path157, _circle42, _circle43, _path158, _circle44, _path159, _path160, _circle45, _circle46, _path161, _circle47, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _circle48, _path172, _circle49, _path173, _circle50, _path174, _path175, _path176, _circle51, _path177, _circle52, _path178, _circle53, _path179, _path180, _path181, _circle54, _path182, _circle55, _path183, _circle56, _path184, _path185, _path186, _circle57, _path187, _circle58, _path188, _circle59, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _circle60, _circle61, _path252, _circle62, _circle63, _path253, _path254, _circle64, _circle65, _path255, _circle66, _circle67, _path256, _path257, _circle68, _circle69, _path258, _circle70, _circle71, _path259, _path260, _circle72, _circle73, _path261, _circle74, _circle75, _path262, _path263, _circle76, _circle77, _circle78, _path264, _path265, _circle79, _circle80, _circle81, _path266, _path267, _circle82, _circle83, _circle84, _path268, _path269, _circle85, _circle86, _circle87, _path270, _path271, _circle88, _path272, _circle89, _path273, _circle90, _path274, _circle91, _path275, _circle92, _path276, _circle93, _path277, _circle94, _path278, _circle95, _path279, _circle96, _path280, _circle97, _path281, _circle98, _path282, _circle99, _path283, _circle100, _path284, _circle101, _path285, _circle102, _path286, _circle103, _path287, _path288, _path289, _path290, _path291, _circle104, _path292, _circle105, _path293, _path294, _circle106, _path295, _circle107, _path296, _path297, _circle108, _path298, _circle109, _path299, _path300, _circle110, _path301, _circle111, _path302, _path303, _circle112, _circle113, _circle114, _path304, _path305, _circle115, _circle116, _circle117, _path306, _path307, _circle118, _circle119, _circle120, _path308, _path309, _circle121, _circle122, _circle123, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _circle124, _path355, _circle125, _path356, _path357, _path358, _path359, _path360, _circle126, _path361, _circle127, _path362, _path363, _path364, _path365, _path366, _circle128, _path367, _circle129, _path368, _path369, _path370, _path371, _path372, _circle130, _path373, _circle131, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _circle132, _path503, _path504, _circle133, _path505, _path506, _circle134, _path507, _path508, _circle135, _path509, _path510, _path511, _circle136, _path512, _path513, _circle137, _path514, _path515, _circle138, _path516, _path517, _circle139, _path518, _path519, _path520, _path521;

var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"],
    _excluded5 = ["children"],
    _excluded6 = ["children"],
    _excluded7 = ["children"],
    _excluded8 = ["children"],
    _excluded9 = ["children"],
    _excluded10 = ["children"],
    _excluded11 = ["children"],
    _excluded12 = ["children"],
    _excluded13 = ["children"],
    _excluded14 = ["children"],
    _excluded15 = ["children"],
    _excluded16 = ["children"],
    _excluded17 = ["children"],
    _excluded18 = ["children"],
    _excluded19 = ["children"],
    _excluded20 = ["children"],
    _excluded21 = ["children"],
    _excluded22 = ["children"],
    _excluded23 = ["children"],
    _excluded24 = ["children"],
    _excluded25 = ["children"],
    _excluded26 = ["children"],
    _excluded27 = ["children"],
    _excluded28 = ["children"],
    _excluded29 = ["children"],
    _excluded30 = ["children"],
    _excluded31 = ["children"],
    _excluded32 = ["children"],
    _excluded33 = ["children"],
    _excluded34 = ["children"],
    _excluded35 = ["children"],
    _excluded36 = ["children"],
    _excluded37 = ["children"],
    _excluded38 = ["children"],
    _excluded39 = ["children"],
    _excluded40 = ["children"],
    _excluded41 = ["children"],
    _excluded42 = ["children"],
    _excluded43 = ["children"],
    _excluded44 = ["children"],
    _excluded45 = ["children"],
    _excluded46 = ["children"],
    _excluded47 = ["children"],
    _excluded48 = ["children"],
    _excluded49 = ["children"],
    _excluded50 = ["children"],
    _excluded51 = ["children"],
    _excluded52 = ["children"],
    _excluded53 = ["children"],
    _excluded54 = ["children"],
    _excluded55 = ["children"],
    _excluded56 = ["children"],
    _excluded57 = ["children"],
    _excluded58 = ["children"],
    _excluded59 = ["children"],
    _excluded60 = ["children"],
    _excluded61 = ["children"],
    _excluded62 = ["children"],
    _excluded63 = ["children"],
    _excluded64 = ["children"],
    _excluded65 = ["children"],
    _excluded66 = ["children"],
    _excluded67 = ["children"],
    _excluded68 = ["children"],
    _excluded69 = ["children"],
    _excluded70 = ["children"],
    _excluded71 = ["children"],
    _excluded72 = ["children"],
    _excluded73 = ["children"],
    _excluded74 = ["children"],
    _excluded75 = ["children"],
    _excluded76 = ["children"],
    _excluded77 = ["children"],
    _excluded78 = ["children"],
    _excluded79 = ["children"],
    _excluded80 = ["children"],
    _excluded81 = ["children"],
    _excluded82 = ["children"],
    _excluded83 = ["children"],
    _excluded84 = ["children"],
    _excluded85 = ["children"],
    _excluded86 = ["children"],
    _excluded87 = ["children"],
    _excluded88 = ["children"],
    _excluded89 = ["children"],
    _excluded90 = ["children"],
    _excluded91 = ["children"],
    _excluded92 = ["children"],
    _excluded93 = ["children"],
    _excluded94 = ["children"],
    _excluded95 = ["children"],
    _excluded96 = ["children"],
    _excluded97 = ["children"],
    _excluded98 = ["children"],
    _excluded99 = ["children"],
    _excluded100 = ["children"],
    _excluded101 = ["children"],
    _excluded102 = ["children"],
    _excluded103 = ["children"],
    _excluded104 = ["children"],
    _excluded105 = ["children"],
    _excluded106 = ["children"],
    _excluded107 = ["children"],
    _excluded108 = ["children"],
    _excluded109 = ["children"],
    _excluded110 = ["children"],
    _excluded111 = ["children"],
    _excluded112 = ["children"],
    _excluded113 = ["children"],
    _excluded114 = ["children"],
    _excluded115 = ["children"],
    _excluded116 = ["children"],
    _excluded117 = ["children"],
    _excluded118 = ["children"],
    _excluded119 = ["children"],
    _excluded120 = ["children"],
    _excluded121 = ["children"],
    _excluded122 = ["children"],
    _excluded123 = ["children"],
    _excluded124 = ["children"],
    _excluded125 = ["children"],
    _excluded126 = ["children"],
    _excluded127 = ["children"],
    _excluded128 = ["children"],
    _excluded129 = ["children"],
    _excluded130 = ["children"],
    _excluded131 = ["children"],
    _excluded132 = ["children"],
    _excluded133 = ["children"],
    _excluded134 = ["children"],
    _excluded135 = ["children"],
    _excluded136 = ["children"],
    _excluded137 = ["children"],
    _excluded138 = ["children"],
    _excluded139 = ["children"],
    _excluded140 = ["children"],
    _excluded141 = ["children"],
    _excluded142 = ["children"],
    _excluded143 = ["children"],
    _excluded144 = ["children"],
    _excluded145 = ["children"],
    _excluded146 = ["children"],
    _excluded147 = ["children"],
    _excluded148 = ["children"],
    _excluded149 = ["children"],
    _excluded150 = ["children"],
    _excluded151 = ["children"],
    _excluded152 = ["children"],
    _excluded153 = ["children"],
    _excluded154 = ["children"],
    _excluded155 = ["children"],
    _excluded156 = ["children"],
    _excluded157 = ["children"],
    _excluded158 = ["children"],
    _excluded159 = ["children"],
    _excluded160 = ["children"],
    _excluded161 = ["children"],
    _excluded162 = ["children"],
    _excluded163 = ["children"],
    _excluded164 = ["children"],
    _excluded165 = ["children"],
    _excluded166 = ["children"],
    _excluded167 = ["children"],
    _excluded168 = ["children"],
    _excluded169 = ["children"],
    _excluded170 = ["children"],
    _excluded171 = ["children"],
    _excluded172 = ["children"],
    _excluded173 = ["children"],
    _excluded174 = ["children"],
    _excluded175 = ["children"],
    _excluded176 = ["children"],
    _excluded177 = ["children"],
    _excluded178 = ["children"],
    _excluded179 = ["children"],
    _excluded180 = ["children"],
    _excluded181 = ["children"],
    _excluded182 = ["children"],
    _excluded183 = ["children"],
    _excluded184 = ["children"],
    _excluded185 = ["children"],
    _excluded186 = ["children"],
    _excluded187 = ["children"],
    _excluded188 = ["children"],
    _excluded189 = ["children"],
    _excluded190 = ["children"],
    _excluded191 = ["children"],
    _excluded192 = ["children"],
    _excluded193 = ["children"],
    _excluded194 = ["children"],
    _excluded195 = ["children"],
    _excluded196 = ["children"],
    _excluded197 = ["children"],
    _excluded198 = ["children"],
    _excluded199 = ["children"],
    _excluded200 = ["children"],
    _excluded201 = ["children"],
    _excluded202 = ["children"],
    _excluded203 = ["children"],
    _excluded204 = ["children"],
    _excluded205 = ["children"],
    _excluded206 = ["children"],
    _excluded207 = ["children"],
    _excluded208 = ["children"],
    _excluded209 = ["children"],
    _excluded210 = ["children"],
    _excluded211 = ["children"],
    _excluded212 = ["children"],
    _excluded213 = ["children"],
    _excluded214 = ["children"],
    _excluded215 = ["children"],
    _excluded216 = ["children"],
    _excluded217 = ["children"],
    _excluded218 = ["children"],
    _excluded219 = ["children"],
    _excluded220 = ["children"],
    _excluded221 = ["children"],
    _excluded222 = ["children"],
    _excluded223 = ["children"],
    _excluded224 = ["children"],
    _excluded225 = ["children"],
    _excluded226 = ["children"],
    _excluded227 = ["children"],
    _excluded228 = ["children"],
    _excluded229 = ["children"],
    _excluded230 = ["children"],
    _excluded231 = ["children"],
    _excluded232 = ["children"],
    _excluded233 = ["children"],
    _excluded234 = ["children"],
    _excluded235 = ["children"],
    _excluded236 = ["children"],
    _excluded237 = ["children"],
    _excluded238 = ["children"],
    _excluded239 = ["children"],
    _excluded240 = ["children"],
    _excluded241 = ["children"],
    _excluded242 = ["children"],
    _excluded243 = ["children"],
    _excluded244 = ["children"],
    _excluded245 = ["children"],
    _excluded246 = ["children"],
    _excluded247 = ["children"],
    _excluded248 = ["children"],
    _excluded249 = ["children"],
    _excluded250 = ["children"];
var IbmCloudVirtualServerClassic24 = /*#__PURE__*/React.forwardRef(function IbmCloudVirtualServerClassic24(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26,22h-5v2h5v4H6v-4h9c1.1,0,2-.9,2-2h0v-9.17l2.59,2.59,1.41-1.42-5-5-5,5,1.41,1.41,2.59-2.58v9.17H6c-1.1,0-2,.9-2,2v4c0,1.1.9,2,2,2h20c1.1,0,2-.9,2-2v-4c0-1.1-.9-2-2-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.75,8.05c-.88-3.5-4.08-6.05-7.75-6.05s-6.87,2.55-7.75,6.05c-2.96.37-5.25,2.9-5.25,5.95,0,3.31,2.69,6,6,6h2v-2h-2c-2.21,0-4-1.79-4-4,0-2.19,1.77-3.97,3.95-4l.99.02.12-.88c.43-2.93,2.98-5.14,5.94-5.14s5.51,2.21,5.93,5.15l.12.88.88-.02.13-.01c2.18.03,3.94,1.81,3.94,4,0,2.21-1.79,4-4,4h-2v2h2c3.31,0,6-2.69,6-6,0-3.05-2.29-5.58-5.25-5.95Z"
  })), children);
});
var IbmCloudVirtualServerClassic20 = /*#__PURE__*/React.forwardRef(function IbmCloudVirtualServerClassic20(_ref2, ref) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m26,22h-5v2h5v4H6v-4h9c1.1,0,2-.9,2-2h0v-9.17l2.59,2.59,1.41-1.42-5-5-5,5,1.41,1.41,2.59-2.58v9.17H6c-1.1,0-2,.9-2,2v4c0,1.1.9,2,2,2h20c1.1,0,2-.9,2-2v-4c0-1.1-.9-2-2-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m23.75,8.05c-.88-3.5-4.08-6.05-7.75-6.05s-6.87,2.55-7.75,6.05c-2.96.37-5.25,2.9-5.25,5.95,0,3.31,2.69,6,6,6h2v-2h-2c-2.21,0-4-1.79-4-4,0-2.19,1.77-3.97,3.95-4l.99.02.12-.88c.43-2.93,2.98-5.14,5.94-5.14s5.51,2.21,5.93,5.15l.12.88.88-.02.13-.01c2.18.03,3.94,1.81,3.94,4,0,2.21-1.79,4-4,4h-2v2h2c3.31,0,6-2.69,6-6,0-3.05-2.29-5.58-5.25-5.95Z"
  })), children);
});
var IbmCloudVirtualServerClassic16 = /*#__PURE__*/React.forwardRef(function IbmCloudVirtualServerClassic16(_ref3, ref) {
  var children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "26",
    r: "1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m26,22h-5v2h5v4H6v-4h9c1.1,0,2-.9,2-2h0v-9.17l2.59,2.59,1.41-1.42-5-5-5,5,1.41,1.41,2.59-2.58v9.17H6c-1.1,0-2,.9-2,2v4c0,1.1.9,2,2,2h20c1.1,0,2-.9,2-2v-4c0-1.1-.9-2-2-2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m23.75,8.05c-.88-3.5-4.08-6.05-7.75-6.05s-6.87,2.55-7.75,6.05c-2.96.37-5.25,2.9-5.25,5.95,0,3.31,2.69,6,6,6h2v-2h-2c-2.21,0-4-1.79-4-4,0-2.19,1.77-3.97,3.95-4l.99.02.12-.88c.43-2.93,2.98-5.14,5.94-5.14s5.51,2.21,5.93,5.15l.12.88.88-.02.13-.01c2.18.03,3.94,1.81,3.94,4,0,2.21-1.79,4-4,4h-2v2h2c3.31,0,6-2.69,6-6,0-3.05-2.29-5.58-5.25-5.95Z"
  })), children);
});
var IbmCloudVirtualServerVpc32 = /*#__PURE__*/React.forwardRef(function IbmCloudVirtualServerVpc32(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "26",
    r: "1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30h22c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2zm0-6h22v4H5v-4zM23 20h-14c-3.31 0-6-2.69-6-6 0-3.05 2.29-5.58 5.25-5.95.88-3.5 4.08-6.05 7.75-6.05s6.87 2.55 7.75 6.05c2.96.37 5.25 2.9 5.25 5.95 0 3.31-2.69 6-6 6zm-14.05-10c-2.18.03-3.95 1.81-3.95 4 0 2.21 1.79 4 4 4h14c2.21 0 4-1.79 4-4 0-2.19-1.76-3.97-3.94-4l-.12.01-.88.02-.12-.88c-.43-2.94-2.98-5.15-5.94-5.15s-5.51 2.21-5.93 5.15l-.12.88-1-.03z"
  })), children);
});
var IbmCloudVirtualServerVpc24 = /*#__PURE__*/React.forwardRef(function IbmCloudVirtualServerVpc24(_ref5, ref) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "26",
    r: "1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30h22c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2zm0-6h22v4H5v-4zM23 20h-14c-3.31 0-6-2.69-6-6 0-3.05 2.29-5.58 5.25-5.95.88-3.5 4.08-6.05 7.75-6.05s6.87 2.55 7.75 6.05c2.96.37 5.25 2.9 5.25 5.95 0 3.31-2.69 6-6 6zm-14.05-10c-2.18.03-3.95 1.81-3.95 4 0 2.21 1.79 4 4 4h14c2.21 0 4-1.79 4-4 0-2.19-1.76-3.97-3.94-4l-.12.01-.88.02-.12-.88c-.43-2.94-2.98-5.15-5.94-5.15s-5.51 2.21-5.93 5.15l-.12.88-1-.03z"
  })), children);
});
var IbmCloudVirtualServerVpc20 = /*#__PURE__*/React.forwardRef(function IbmCloudVirtualServerVpc20(_ref6, ref) {
  var children = _ref6.children,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "26",
    r: "1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30h22c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2zm0-6h22v4H5v-4zM23 20h-14c-3.31 0-6-2.69-6-6 0-3.05 2.29-5.58 5.25-5.95.88-3.5 4.08-6.05 7.75-6.05s6.87 2.55 7.75 6.05c2.96.37 5.25 2.9 5.25 5.95 0 3.31-2.69 6-6 6zm-14.05-10c-2.18.03-3.95 1.81-3.95 4 0 2.21 1.79 4 4 4h14c2.21 0 4-1.79 4-4 0-2.19-1.76-3.97-3.94-4l-.12.01-.88.02-.12-.88c-.43-2.94-2.98-5.15-5.94-5.15s-5.51 2.21-5.93 5.15l-.12.88-1-.03z"
  })), children);
});
var IbmCloudVirtualServerVpc16 = /*#__PURE__*/React.forwardRef(function IbmCloudVirtualServerVpc16(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "26",
    r: "1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30h22c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2zm0-6h22v4H5v-4zM23 20h-14c-3.31 0-6-2.69-6-6 0-3.05 2.29-5.58 5.25-5.95.88-3.5 4.08-6.05 7.75-6.05s6.87 2.55 7.75 6.05c2.96.37 5.25 2.9 5.25 5.95 0 3.31-2.69 6-6 6zm-14.05-10c-2.18.03-3.95 1.81-3.95 4 0 2.21 1.79 4 4 4h14c2.21 0 4-1.79 4-4 0-2.19-1.76-3.97-3.94-4l-.12.01-.88.02-.12-.88c-.43-2.94-2.98-5.15-5.94-5.15s-5.51 2.21-5.93 5.15l-.12.88-1-.03z"
  })), children);
});
var IbmCloudVpc32 = /*#__PURE__*/React.forwardRef(function IbmCloudVpc32(_ref8, ref) {
  var children = _ref8.children,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m23.4141,22l-13.4141-13.4141V2H2v8h6.5859l13.4141,13.4141v6.5859h8v-8h-6.5859ZM8,8h-4V4h4v4Zm20,20h-4v-4h4v4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6c0-2.2056-1.7944-4-4-4-1.8584 0-3.4106 1.2798-3.8579 3h-9.1421v2h9.1421c.3638 1.3989 1.4592 2.4941 2.8579 2.8579v9.1421h2v-9.1421c1.7202-.4473 3-1.9995 3-3.8579zm-4 2c-1.103 0-2-.8975-2-2s.897-2 2-2 2 .8975 2 2-.897 2-2 2zM19 25h-9.1421c-.3638-1.3989-1.4592-2.4941-2.8579-2.8579v-9.1421h-2v9.1421c-1.7202.4473-3 1.9995-3 3.8579 0 2.2056 1.7944 4 4 4 1.8584 0 3.4106-1.2798 3.8579-3h9.1421v-2zm-13 3c-1.103 0-2-.8975-2-2s.897-2 2-2 2 .8975 2 2-.897 2-2 2z"
  })), children);
});
var IbmCloudVpc24 = /*#__PURE__*/React.forwardRef(function IbmCloudVpc24(_ref9, ref) {
  var children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m23.4141,22l-13.4141-13.4141V2H2v8h6.5859l13.4141,13.4141v6.5859h8v-8h-6.5859ZM8,8h-4V4h4v4Zm20,20h-4v-4h4v4Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6c0-2.2056-1.7944-4-4-4-1.8584 0-3.4106 1.2798-3.8579 3h-9.1421v2h9.1421c.3638 1.3989 1.4592 2.4941 2.8579 2.8579v9.1421h2v-9.1421c1.7202-.4473 3-1.9995 3-3.8579zm-4 2c-1.103 0-2-.8975-2-2s.897-2 2-2 2 .8975 2 2-.897 2-2 2zM19 25h-9.1421c-.3638-1.3989-1.4592-2.4941-2.8579-2.8579v-9.1421h-2v9.1421c-1.7202.4473-3 1.9995-3 3.8579 0 2.2056 1.7944 4 4 4 1.8584 0 3.4106-1.2798 3.8579-3h9.1421v-2zm-13 3c-1.103 0-2-.8975-2-2s.897-2 2-2 2 .8975 2 2-.897 2-2 2z"
  })), children);
});
var IbmCloudVpc20 = /*#__PURE__*/React.forwardRef(function IbmCloudVpc20(_ref10, ref) {
  var children = _ref10.children,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m23.4141,22l-13.4141-13.4141V2H2v8h6.5859l13.4141,13.4141v6.5859h8v-8h-6.5859ZM8,8h-4V4h4v4Zm20,20h-4v-4h4v4Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6c0-2.2056-1.7944-4-4-4-1.8584 0-3.4106 1.2798-3.8579 3h-9.1421v2h9.1421c.3638 1.3989 1.4592 2.4941 2.8579 2.8579v9.1421h2v-9.1421c1.7202-.4473 3-1.9995 3-3.8579zm-4 2c-1.103 0-2-.8975-2-2s.897-2 2-2 2 .8975 2 2-.897 2-2 2zM19 25h-9.1421c-.3638-1.3989-1.4592-2.4941-2.8579-2.8579v-9.1421h-2v9.1421c-1.7202.4473-3 1.9995-3 3.8579 0 2.2056 1.7944 4 4 4 1.8584 0 3.4106-1.2798 3.8579-3h9.1421v-2zm-13 3c-1.103 0-2-.8975-2-2s.897-2 2-2 2 .8975 2 2-.897 2-2 2z"
  })), children);
});
var IbmCloudVpc16 = /*#__PURE__*/React.forwardRef(function IbmCloudVpc16(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m23.4141,22l-13.4141-13.4141V2H2v8h6.5859l13.4141,13.4141v6.5859h8v-8h-6.5859ZM8,8h-4V4h4v4Zm20,20h-4v-4h4v4Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6c0-2.2056-1.7944-4-4-4-1.8584 0-3.4106 1.2798-3.8579 3h-9.1421v2h9.1421c.3638 1.3989 1.4592 2.4941 2.8579 2.8579v9.1421h2v-9.1421c1.7202-.4473 3-1.9995 3-3.8579zm-4 2c-1.103 0-2-.8975-2-2s.897-2 2-2 2 .8975 2 2-.897 2-2 2zM19 25h-9.1421c-.3638-1.3989-1.4592-2.4941-2.8579-2.8579v-9.1421h-2v9.1421c-1.7202.4473-3 1.9995-3 3.8579 0 2.2056 1.7944 4 4 4 1.8584 0 3.4106-1.2798 3.8579-3h9.1421v-2zm-13 3c-1.103 0-2-.8975-2-2s.897-2 2-2 2 .8975 2 2-.897 2-2 2z"
  })), children);
});
var IbmCloudVpcEndpoints32 = /*#__PURE__*/React.forwardRef(function IbmCloudVpcEndpoints32(_ref12, ref) {
  var children = _ref12.children,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z"
  })), children);
});
var IbmCloudVpcEndpoints24 = /*#__PURE__*/React.forwardRef(function IbmCloudVpcEndpoints24(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z"
  })), children);
});
var IbmCloudVpcEndpoints20 = /*#__PURE__*/React.forwardRef(function IbmCloudVpcEndpoints20(_ref14, ref) {
  var children = _ref14.children,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z"
  })), children);
});
var IbmCloudVpcEndpoints16 = /*#__PURE__*/React.forwardRef(function IbmCloudVpcEndpoints16(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, _excluded15);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z"
  })), children);
});
var IbmCloudPakApplications32 = /*#__PURE__*/React.forwardRef(function IbmCloudPakApplications32(_ref16, ref) {
  var children = _ref16.children,
      rest = _objectWithoutProperties(_ref16, _excluded16);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakApplications24 = /*#__PURE__*/React.forwardRef(function IbmCloudPakApplications24(_ref17, ref) {
  var children = _ref17.children,
      rest = _objectWithoutProperties(_ref17, _excluded17);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakApplications20 = /*#__PURE__*/React.forwardRef(function IbmCloudPakApplications20(_ref18, ref) {
  var children = _ref18.children,
      rest = _objectWithoutProperties(_ref18, _excluded18);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakApplications16 = /*#__PURE__*/React.forwardRef(function IbmCloudPakApplications16(_ref19, ref) {
  var children = _ref19.children,
      rest = _objectWithoutProperties(_ref19, _excluded19);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakBusinessAutomation32 = /*#__PURE__*/React.forwardRef(function IbmCloudPakBusinessAutomation32(_ref20, ref) {
  var children = _ref20.children,
      rest = _objectWithoutProperties(_ref20, _excluded20);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null)), children);
});
var IbmCloudPakBusinessAutomation24 = /*#__PURE__*/React.forwardRef(function IbmCloudPakBusinessAutomation24(_ref21, ref) {
  var children = _ref21.children,
      rest = _objectWithoutProperties(_ref21, _excluded21);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch2 || (_switch2 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var IbmCloudPakBusinessAutomation20 = /*#__PURE__*/React.forwardRef(function IbmCloudPakBusinessAutomation20(_ref22, ref) {
  var children = _ref22.children,
      rest = _objectWithoutProperties(_ref22, _excluded22);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch3 || (_switch3 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var IbmCloudPakBusinessAutomation16 = /*#__PURE__*/React.forwardRef(function IbmCloudPakBusinessAutomation16(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, _excluded23);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _switch4 || (_switch4 = /*#__PURE__*/React.createElement("switch", null)), children);
});
var IbmCloudPakData32 = /*#__PURE__*/React.forwardRef(function IbmCloudPakData32(_ref24, ref) {
  var children = _ref24.children,
      rest = _objectWithoutProperties(_ref24, _excluded24);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "15",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "15",
    r: "1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "10",
    r: "1"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "23",
    r: "1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakData24 = /*#__PURE__*/React.forwardRef(function IbmCloudPakData24(_ref25, ref) {
  var children = _ref25.children,
      rest = _objectWithoutProperties(_ref25, _excluded25);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "15",
    r: "1"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "15",
    r: "1"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "10",
    r: "1"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "23",
    r: "1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakData20 = /*#__PURE__*/React.forwardRef(function IbmCloudPakData20(_ref26, ref) {
  var children = _ref26.children,
      rest = _objectWithoutProperties(_ref26, _excluded26);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "15",
    r: "1"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "15",
    r: "1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "10",
    r: "1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "23",
    r: "1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakData16 = /*#__PURE__*/React.forwardRef(function IbmCloudPakData16(_ref27, ref) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, _excluded27);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "15",
    r: "1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "15",
    r: "1"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "10",
    r: "1"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "23",
    r: "1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakIntegration32 = /*#__PURE__*/React.forwardRef(function IbmCloudPakIntegration32(_ref28, ref) {
  var children = _ref28.children,
      rest = _objectWithoutProperties(_ref28, _excluded28);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213 9.8787a3 3 0 00-4.2426 0l-.4645.4644 1.4142 1.4142.4645-.4645a1 1 0 011.4142 1.4144L17.4142 16l1.4143 1.4142 3.2928-3.2929A3 3 0 0022.1213 9.8787zM12.7071 20.7072a1 1 0 01-1.4142-1.4144L14.5858 16l-1.4142-1.4142L9.8787 17.8787a3 3 0 104.2426 4.2426l.4645-.4644-1.4142-1.4143zM14.1213 9.8787a3 3 0 00-4.2426 4.2426l.4645.4645 1.4142-1.4142-.4645-.4645a1 1 0 011.4142-1.4143L16 14.5858l1.4142-1.4143z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakIntegration24 = /*#__PURE__*/React.forwardRef(function IbmCloudPakIntegration24(_ref29, ref) {
  var children = _ref29.children,
      rest = _objectWithoutProperties(_ref29, _excluded29);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213 9.8787a3 3 0 00-4.2426 0l-.4645.4644 1.4142 1.4142.4645-.4645a1 1 0 011.4142 1.4144L17.4142 16l1.4143 1.4142 3.2928-3.2929A3 3 0 0022.1213 9.8787zM12.7071 20.7072a1 1 0 01-1.4142-1.4144L14.5858 16l-1.4142-1.4142L9.8787 17.8787a3 3 0 104.2426 4.2426l.4645-.4644-1.4142-1.4143zM14.1213 9.8787a3 3 0 00-4.2426 4.2426l.4645.4645 1.4142-1.4142-.4645-.4645a1 1 0 011.4142-1.4143L16 14.5858l1.4142-1.4143z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakIntegration20 = /*#__PURE__*/React.forwardRef(function IbmCloudPakIntegration20(_ref30, ref) {
  var children = _ref30.children,
      rest = _objectWithoutProperties(_ref30, _excluded30);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213 9.8787a3 3 0 00-4.2426 0l-.4645.4644 1.4142 1.4142.4645-.4645a1 1 0 011.4142 1.4144L17.4142 16l1.4143 1.4142 3.2928-3.2929A3 3 0 0022.1213 9.8787zM12.7071 20.7072a1 1 0 01-1.4142-1.4144L14.5858 16l-1.4142-1.4142L9.8787 17.8787a3 3 0 104.2426 4.2426l.4645-.4644-1.4142-1.4143zM14.1213 9.8787a3 3 0 00-4.2426 4.2426l.4645.4645 1.4142-1.4142-.4645-.4645a1 1 0 011.4142-1.4143L16 14.5858l1.4142-1.4143z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakIntegration16 = /*#__PURE__*/React.forwardRef(function IbmCloudPakIntegration16(_ref31, ref) {
  var children = _ref31.children,
      rest = _objectWithoutProperties(_ref31, _excluded31);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213 9.8787a3 3 0 00-4.2426 0l-.4645.4644 1.4142 1.4142.4645-.4645a1 1 0 011.4142 1.4144L17.4142 16l1.4143 1.4142 3.2928-3.2929A3 3 0 0022.1213 9.8787zM12.7071 20.7072a1 1 0 01-1.4142-1.4144L14.5858 16l-1.4142-1.4142L9.8787 17.8787a3 3 0 104.2426 4.2426l.4645-.4644-1.4142-1.4143zM14.1213 9.8787a3 3 0 00-4.2426 4.2426l.4645.4645 1.4142-1.4142-.4645-.4645a1 1 0 011.4142-1.4143L16 14.5858l1.4142-1.4143z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakMantaAutomatedDataLineage32 = /*#__PURE__*/React.forwardRef(function IbmCloudPakMantaAutomatedDataLineage32(_ref32, ref) {
  var children = _ref32.children,
      rest = _objectWithoutProperties(_ref32, _excluded32);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z"
  })), children);
});
var IbmCloudPakMantaAutomatedDataLineage24 = /*#__PURE__*/React.forwardRef(function IbmCloudPakMantaAutomatedDataLineage24(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, _excluded33);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z"
  })), children);
});
var IbmCloudPakMantaAutomatedDataLineage20 = /*#__PURE__*/React.forwardRef(function IbmCloudPakMantaAutomatedDataLineage20(_ref34, ref) {
  var children = _ref34.children,
      rest = _objectWithoutProperties(_ref34, _excluded34);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z"
  })), children);
});
var IbmCloudPakMantaAutomatedDataLineage16 = /*#__PURE__*/React.forwardRef(function IbmCloudPakMantaAutomatedDataLineage16(_ref35, ref) {
  var children = _ref35.children,
      rest = _objectWithoutProperties(_ref35, _excluded35);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z"
  })), children);
});
var IbmCloudPakMulticloudMgmt32 = /*#__PURE__*/React.forwardRef(function IbmCloudPakMulticloudMgmt32(_ref36, ref) {
  var children = _ref36.children,
      rest = _objectWithoutProperties(_ref36, _excluded36);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakMulticloudMgmt24 = /*#__PURE__*/React.forwardRef(function IbmCloudPakMulticloudMgmt24(_ref37, ref) {
  var children = _ref37.children,
      rest = _objectWithoutProperties(_ref37, _excluded37);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakMulticloudMgmt20 = /*#__PURE__*/React.forwardRef(function IbmCloudPakMulticloudMgmt20(_ref38, ref) {
  var children = _ref38.children,
      rest = _objectWithoutProperties(_ref38, _excluded38);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakMulticloudMgmt16 = /*#__PURE__*/React.forwardRef(function IbmCloudPakMulticloudMgmt16(_ref39, ref) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, _excluded39);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakNetezza32 = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetezza32(_ref40, ref) {
  var children = _ref40.children,
      rest = _objectWithoutProperties(_ref40, _excluded40);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10L19 19.2 13.5 10 11 10 11 22 13 22 13 12.8 18.5 22 21 22 21 10z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12\tS22.6,4,16,4z"
  })), children);
});
var IbmCloudPakNetezza24 = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetezza24(_ref41, ref) {
  var children = _ref41.children,
      rest = _objectWithoutProperties(_ref41, _excluded41);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10L19 19.2 13.5 10 11 10 11 22 13 22 13 12.8 18.5 22 21 22 21 10z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12\tS22.6,4,16,4z"
  })), children);
});
var IbmCloudPakNetezza20 = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetezza20(_ref42, ref) {
  var children = _ref42.children,
      rest = _objectWithoutProperties(_ref42, _excluded42);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10L19 19.2 13.5 10 11 10 11 22 13 22 13 12.8 18.5 22 21 22 21 10z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12\tS22.6,4,16,4z"
  })), children);
});
var IbmCloudPakNetezza16 = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetezza16(_ref43, ref) {
  var children = _ref43.children,
      rest = _objectWithoutProperties(_ref43, _excluded43);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10L19 19.2 13.5 10 11 10 11 22 13 22 13 12.8 18.5 22 21 22 21 10z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12\tS22.6,4,16,4z"
  })), children);
});
var IbmCloudPakNetworkAutomation32 = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetworkAutomation32(_ref44, ref) {
  var children = _ref44.children,
      rest = _objectWithoutProperties(_ref44, _excluded44);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5356 18.5354l-1.414-1.4141a3.0039 3.0039 0 000-4.2426l1.414-1.4141A5.0048 5.0048 0 0119.5356 18.5354zM17 26H15V15a1 1 0 011-1h0a1 1 0 011 1zM12.4644 18.5354a5.0048 5.0048 0 010-7.0708l1.414 1.4141a3.0039 3.0039 0 000 4.2426z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakNetworkAutomation24 = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetworkAutomation24(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, _excluded45);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5356 18.5354l-1.414-1.4141a3.0039 3.0039 0 000-4.2426l1.414-1.4141A5.0048 5.0048 0 0119.5356 18.5354zM17 26H15V15a1 1 0 011-1h0a1 1 0 011 1zM12.4644 18.5354a5.0048 5.0048 0 010-7.0708l1.414 1.4141a3.0039 3.0039 0 000 4.2426z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakNetworkAutomation20 = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetworkAutomation20(_ref46, ref) {
  var children = _ref46.children,
      rest = _objectWithoutProperties(_ref46, _excluded46);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5356 18.5354l-1.414-1.4141a3.0039 3.0039 0 000-4.2426l1.414-1.4141A5.0048 5.0048 0 0119.5356 18.5354zM17 26H15V15a1 1 0 011-1h0a1 1 0 011 1zM12.4644 18.5354a5.0048 5.0048 0 010-7.0708l1.414 1.4141a3.0039 3.0039 0 000 4.2426z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakNetworkAutomation16 = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetworkAutomation16(_ref47, ref) {
  var children = _ref47.children,
      rest = _objectWithoutProperties(_ref47, _excluded47);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5356 18.5354l-1.414-1.4141a3.0039 3.0039 0 000-4.2426l1.414-1.4141A5.0048 5.0048 0 0119.5356 18.5354zM17 26H15V15a1 1 0 011-1h0a1 1 0 011 1zM12.4644 18.5354a5.0048 5.0048 0 010-7.0708l1.414 1.4141a3.0039 3.0039 0 000 4.2426z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakSecurity32 = /*#__PURE__*/React.forwardRef(function IbmCloudPakSecurity32(_ref48, ref) {
  var children = _ref48.children,
      rest = _objectWithoutProperties(_ref48, _excluded48);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakSecurity24 = /*#__PURE__*/React.forwardRef(function IbmCloudPakSecurity24(_ref49, ref) {
  var children = _ref49.children,
      rest = _objectWithoutProperties(_ref49, _excluded49);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakSecurity20 = /*#__PURE__*/React.forwardRef(function IbmCloudPakSecurity20(_ref50, ref) {
  var children = _ref50.children,
      rest = _objectWithoutProperties(_ref50, _excluded50);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakSecurity16 = /*#__PURE__*/React.forwardRef(function IbmCloudPakSecurity16(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, _excluded51);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakSystem32 = /*#__PURE__*/React.forwardRef(function IbmCloudPakSystem32(_ref52, ref) {
  var children = _ref52.children,
      rest = _objectWithoutProperties(_ref52, _excluded52);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.671H17V15.328H15z",
    transform: "rotate(-45 16 13.5)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.672H17V20.329H15z",
    transform: "rotate(-45 16 18.5)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakSystem24 = /*#__PURE__*/React.forwardRef(function IbmCloudPakSystem24(_ref53, ref) {
  var children = _ref53.children,
      rest = _objectWithoutProperties(_ref53, _excluded53);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.671H17V15.328H15z",
    transform: "rotate(-45 16 13.5)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.672H17V20.329H15z",
    transform: "rotate(-45 16 18.5)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakSystem20 = /*#__PURE__*/React.forwardRef(function IbmCloudPakSystem20(_ref54, ref) {
  var children = _ref54.children,
      rest = _objectWithoutProperties(_ref54, _excluded54);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.671H17V15.328H15z",
    transform: "rotate(-45 16 13.5)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.672H17V20.329H15z",
    transform: "rotate(-45 16 18.5)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakSystem16 = /*#__PURE__*/React.forwardRef(function IbmCloudPakSystem16(_ref55, ref) {
  var children = _ref55.children,
      rest = _objectWithoutProperties(_ref55, _excluded55);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.671H17V15.328H15z",
    transform: "rotate(-45 16 13.5)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.672H17V20.329H15z",
    transform: "rotate(-45 16 18.5)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakWatsonAiops32 = /*#__PURE__*/React.forwardRef(function IbmCloudPakWatsonAiops32(_ref56, ref) {
  var children = _ref56.children,
      rest = _objectWithoutProperties(_ref56, _excluded56);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakWatsonAiops24 = /*#__PURE__*/React.forwardRef(function IbmCloudPakWatsonAiops24(_ref57, ref) {
  var children = _ref57.children,
      rest = _objectWithoutProperties(_ref57, _excluded57);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakWatsonAiops20 = /*#__PURE__*/React.forwardRef(function IbmCloudPakWatsonAiops20(_ref58, ref) {
  var children = _ref58.children,
      rest = _objectWithoutProperties(_ref58, _excluded58);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmCloudPakWatsonAiops16 = /*#__PURE__*/React.forwardRef(function IbmCloudPakWatsonAiops16(_ref59, ref) {
  var children = _ref59.children,
      rest = _objectWithoutProperties(_ref59, _excluded59);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
var IbmSecurity32 = /*#__PURE__*/React.forwardRef(function IbmSecurity32(_ref60, ref) {
  var children = _ref60.children,
      rest = _objectWithoutProperties(_ref60, _excluded60);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
  })), children);
});
var IbmSecurity24 = /*#__PURE__*/React.forwardRef(function IbmSecurity24(_ref61, ref) {
  var children = _ref61.children,
      rest = _objectWithoutProperties(_ref61, _excluded61);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
  })), children);
});
var IbmSecurity20 = /*#__PURE__*/React.forwardRef(function IbmSecurity20(_ref62, ref) {
  var children = _ref62.children,
      rest = _objectWithoutProperties(_ref62, _excluded62);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
  })), children);
});
var IbmSecurity16 = /*#__PURE__*/React.forwardRef(function IbmSecurity16(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, _excluded63);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
  })), children);
});
var IbmSecurityServices32 = /*#__PURE__*/React.forwardRef(function IbmSecurityServices32(_ref64, ref) {
  var children = _ref64.children,
      rest = _objectWithoutProperties(_ref64, _excluded64);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z"
  })), children);
});
var IbmSecurityServices24 = /*#__PURE__*/React.forwardRef(function IbmSecurityServices24(_ref65, ref) {
  var children = _ref65.children,
      rest = _objectWithoutProperties(_ref65, _excluded65);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z"
  })), children);
});
var IbmSecurityServices20 = /*#__PURE__*/React.forwardRef(function IbmSecurityServices20(_ref66, ref) {
  var children = _ref66.children,
      rest = _objectWithoutProperties(_ref66, _excluded66);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z"
  })), children);
});
var IbmSecurityServices16 = /*#__PURE__*/React.forwardRef(function IbmSecurityServices16(_ref67, ref) {
  var children = _ref67.children,
      rest = _objectWithoutProperties(_ref67, _excluded67);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z"
  })), children);
});
var IbmWatsonAssistant32 = /*#__PURE__*/React.forwardRef(function IbmWatsonAssistant32(_ref68, ref) {
  var children = _ref68.children,
      rest = _objectWithoutProperties(_ref68, _excluded68);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H18c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H18V4h10v6h-3v2h3c1.1 0 2-.9 2-2V4C30 2.9 29.1 2 28 2zM14.7 31L13 30l3.5-6H22c1.1 0 2-.9 2-2v-5h2v5c0 2.2-1.8 4-4 4h-4.4L14.7 31z"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z"
  })), children);
});
var IbmWatsonAssistant24 = /*#__PURE__*/React.forwardRef(function IbmWatsonAssistant24(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, _excluded69);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H18c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H18V4h10v6h-3v2h3c1.1 0 2-.9 2-2V4C30 2.9 29.1 2 28 2zM14.7 31L13 30l3.5-6H22c1.1 0 2-.9 2-2v-5h2v5c0 2.2-1.8 4-4 4h-4.4L14.7 31z"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z"
  })), children);
});
var IbmWatsonAssistant20 = /*#__PURE__*/React.forwardRef(function IbmWatsonAssistant20(_ref70, ref) {
  var children = _ref70.children,
      rest = _objectWithoutProperties(_ref70, _excluded70);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H18c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H18V4h10v6h-3v2h3c1.1 0 2-.9 2-2V4C30 2.9 29.1 2 28 2zM14.7 31L13 30l3.5-6H22c1.1 0 2-.9 2-2v-5h2v5c0 2.2-1.8 4-4 4h-4.4L14.7 31z"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z"
  })), children);
});
var IbmWatsonAssistant16 = /*#__PURE__*/React.forwardRef(function IbmWatsonAssistant16(_ref71, ref) {
  var children = _ref71.children,
      rest = _objectWithoutProperties(_ref71, _excluded71);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H18c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H18V4h10v6h-3v2h3c1.1 0 2-.9 2-2V4C30 2.9 29.1 2 28 2zM14.7 31L13 30l3.5-6H22c1.1 0 2-.9 2-2v-5h2v5c0 2.2-1.8 4-4 4h-4.4L14.7 31z"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z"
  })), children);
});
var IbmWatsonDiscovery32 = /*#__PURE__*/React.forwardRef(function IbmWatsonDiscovery32(_ref72, ref) {
  var children = _ref72.children,
      rest = _objectWithoutProperties(_ref72, _excluded72);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17H14V19H6z"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "18",
    r: "1"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "14",
    r: "1"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13H10V15H2zM6 9H14V11H6z"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "10",
    r: "1"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4\tc5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z"
  })), children);
});
var IbmWatsonDiscovery24 = /*#__PURE__*/React.forwardRef(function IbmWatsonDiscovery24(_ref73, ref) {
  var children = _ref73.children,
      rest = _objectWithoutProperties(_ref73, _excluded73);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17H14V19H6z"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "18",
    r: "1"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "14",
    r: "1"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13H10V15H2zM6 9H14V11H6z"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "10",
    r: "1"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4\tc5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z"
  })), children);
});
var IbmWatsonDiscovery20 = /*#__PURE__*/React.forwardRef(function IbmWatsonDiscovery20(_ref74, ref) {
  var children = _ref74.children,
      rest = _objectWithoutProperties(_ref74, _excluded74);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17H14V19H6z"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "18",
    r: "1"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "14",
    r: "1"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13H10V15H2zM6 9H14V11H6z"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "10",
    r: "1"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4\tc5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z"
  })), children);
});
var IbmWatsonDiscovery16 = /*#__PURE__*/React.forwardRef(function IbmWatsonDiscovery16(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, _excluded75);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17H14V19H6z"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "18",
    r: "1"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "14",
    r: "1"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13H10V15H2zM6 9H14V11H6z"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "10",
    r: "1"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4\tc5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z"
  })), children);
});
var IbmWatsonKnowledgeCatalog32 = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeCatalog32(_ref76, ref) {
  var children = _ref76.children,
      rest = _objectWithoutProperties(_ref76, _excluded76);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6zM12 18H20V20H12zM12 13H20V15H12zM12 8H20V10H12z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4\tc0,1.1,0.9,2,2,2h10V28z"
  })), children);
});
var IbmWatsonKnowledgeCatalog24 = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeCatalog24(_ref77, ref) {
  var children = _ref77.children,
      rest = _objectWithoutProperties(_ref77, _excluded77);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6zM12 18H20V20H12zM12 13H20V15H12zM12 8H20V10H12z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4\tc0,1.1,0.9,2,2,2h10V28z"
  })), children);
});
var IbmWatsonKnowledgeCatalog20 = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeCatalog20(_ref78, ref) {
  var children = _ref78.children,
      rest = _objectWithoutProperties(_ref78, _excluded78);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6zM12 18H20V20H12zM12 13H20V15H12zM12 8H20V10H12z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4\tc0,1.1,0.9,2,2,2h10V28z"
  })), children);
});
var IbmWatsonKnowledgeCatalog16 = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeCatalog16(_ref79, ref) {
  var children = _ref79.children,
      rest = _objectWithoutProperties(_ref79, _excluded79);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6zM12 18H20V20H12zM12 13H20V15H12zM12 8H20V10H12z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4\tc0,1.1,0.9,2,2,2h10V28z"
  })), children);
});
var IbmWatsonKnowledgeStudio32 = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeStudio32(_ref80, ref) {
  var children = _ref80.children,
      rest = _objectWithoutProperties(_ref80, _excluded80);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25H27V27H20zM22 29H25V31H22zM27 23h-2c0-1.1.4-2 1.2-2.8l.5-.5c.8-.8 1.3-2 1.3-3.2 0-2.5-2-4.5-4.5-4.5S19 14 19 16.5c0 1.2.5 2.3 1.3 3.2l.5.5C21.6 21 22 21.9 22 23h-2c0-.5-.2-1-.6-1.4l-.5-.5c-1.2-1.2-1.9-2.9-1.9-4.6 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.7-.7 3.4-1.9 4.6l-.5.5C27.2 22 27 22.5 27 23zM6 22H14V24H6z"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "19",
    r: "1"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H9V20H6zM6 14H13V16H6zM10 10H17V12H10z"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "11",
    r: "1"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H20V8H16z"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "7",
    r: "1"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V8H6z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z"
  })), children);
});
var IbmWatsonKnowledgeStudio24 = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeStudio24(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, _excluded81);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25H27V27H20zM22 29H25V31H22zM27 23h-2c0-1.1.4-2 1.2-2.8l.5-.5c.8-.8 1.3-2 1.3-3.2 0-2.5-2-4.5-4.5-4.5S19 14 19 16.5c0 1.2.5 2.3 1.3 3.2l.5.5C21.6 21 22 21.9 22 23h-2c0-.5-.2-1-.6-1.4l-.5-.5c-1.2-1.2-1.9-2.9-1.9-4.6 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.7-.7 3.4-1.9 4.6l-.5.5C27.2 22 27 22.5 27 23zM6 22H14V24H6z"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "19",
    r: "1"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H9V20H6zM6 14H13V16H6zM10 10H17V12H10z"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "11",
    r: "1"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H20V8H16z"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "7",
    r: "1"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V8H6z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z"
  })), children);
});
var IbmWatsonKnowledgeStudio20 = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeStudio20(_ref82, ref) {
  var children = _ref82.children,
      rest = _objectWithoutProperties(_ref82, _excluded82);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25H27V27H20zM22 29H25V31H22zM27 23h-2c0-1.1.4-2 1.2-2.8l.5-.5c.8-.8 1.3-2 1.3-3.2 0-2.5-2-4.5-4.5-4.5S19 14 19 16.5c0 1.2.5 2.3 1.3 3.2l.5.5C21.6 21 22 21.9 22 23h-2c0-.5-.2-1-.6-1.4l-.5-.5c-1.2-1.2-1.9-2.9-1.9-4.6 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.7-.7 3.4-1.9 4.6l-.5.5C27.2 22 27 22.5 27 23zM6 22H14V24H6z"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "19",
    r: "1"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H9V20H6zM6 14H13V16H6zM10 10H17V12H10z"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "11",
    r: "1"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H20V8H16z"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "7",
    r: "1"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V8H6z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z"
  })), children);
});
var IbmWatsonKnowledgeStudio16 = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeStudio16(_ref83, ref) {
  var children = _ref83.children,
      rest = _objectWithoutProperties(_ref83, _excluded83);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25H27V27H20zM22 29H25V31H22zM27 23h-2c0-1.1.4-2 1.2-2.8l.5-.5c.8-.8 1.3-2 1.3-3.2 0-2.5-2-4.5-4.5-4.5S19 14 19 16.5c0 1.2.5 2.3 1.3 3.2l.5.5C21.6 21 22 21.9 22 23h-2c0-.5-.2-1-.6-1.4l-.5-.5c-1.2-1.2-1.9-2.9-1.9-4.6 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.7-.7 3.4-1.9 4.6l-.5.5C27.2 22 27 22.5 27 23zM6 22H14V24H6z"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "19",
    r: "1"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H9V20H6zM6 14H13V16H6zM10 10H17V12H10z"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "11",
    r: "1"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H20V8H16z"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "7",
    r: "1"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V8H6z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z"
  })), children);
});
var IbmWatsonLanguageTranslator32 = /*#__PURE__*/React.forwardRef(function IbmWatsonLanguageTranslator32(_ref84, ref) {
  var children = _ref84.children,
      rest = _objectWithoutProperties(_ref84, _excluded84);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28h-3c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h3V28zM28 30h2.2l-4.6-11h-2.2l-4.6 11H21l.8-2h5.3L28 30zM22.7 26l1.8-4.4 1.8 4.4H22.7zM28 15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9 0 7 3.1 7 7V15zM14 5V3H9V1H7v2H2v2h8.2C10 5.9 9.4 7.5 8 9 7.4 8.3 6.9 7.6 6.6 7H4.3c.4 1 1.1 2.2 2.1 3.3C5.6 11 4.4 11.6 3 12.1L3.7 14c1.8-.7 3.2-1.5 4.3-2.3 1.1.9 2.5 1.7 4.3 2.3l.7-1.9c-1.4-.5-2.6-1.2-3.5-1.8 1.9-2 2.5-4.1 2.7-5.3H14z"
  })), children);
});
var IbmWatsonLanguageTranslator24 = /*#__PURE__*/React.forwardRef(function IbmWatsonLanguageTranslator24(_ref85, ref) {
  var children = _ref85.children,
      rest = _objectWithoutProperties(_ref85, _excluded85);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28h-3c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h3V28zM28 30h2.2l-4.6-11h-2.2l-4.6 11H21l.8-2h5.3L28 30zM22.7 26l1.8-4.4 1.8 4.4H22.7zM28 15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9 0 7 3.1 7 7V15zM14 5V3H9V1H7v2H2v2h8.2C10 5.9 9.4 7.5 8 9 7.4 8.3 6.9 7.6 6.6 7H4.3c.4 1 1.1 2.2 2.1 3.3C5.6 11 4.4 11.6 3 12.1L3.7 14c1.8-.7 3.2-1.5 4.3-2.3 1.1.9 2.5 1.7 4.3 2.3l.7-1.9c-1.4-.5-2.6-1.2-3.5-1.8 1.9-2 2.5-4.1 2.7-5.3H14z"
  })), children);
});
var IbmWatsonLanguageTranslator20 = /*#__PURE__*/React.forwardRef(function IbmWatsonLanguageTranslator20(_ref86, ref) {
  var children = _ref86.children,
      rest = _objectWithoutProperties(_ref86, _excluded86);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28h-3c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h3V28zM28 30h2.2l-4.6-11h-2.2l-4.6 11H21l.8-2h5.3L28 30zM22.7 26l1.8-4.4 1.8 4.4H22.7zM28 15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9 0 7 3.1 7 7V15zM14 5V3H9V1H7v2H2v2h8.2C10 5.9 9.4 7.5 8 9 7.4 8.3 6.9 7.6 6.6 7H4.3c.4 1 1.1 2.2 2.1 3.3C5.6 11 4.4 11.6 3 12.1L3.7 14c1.8-.7 3.2-1.5 4.3-2.3 1.1.9 2.5 1.7 4.3 2.3l.7-1.9c-1.4-.5-2.6-1.2-3.5-1.8 1.9-2 2.5-4.1 2.7-5.3H14z"
  })), children);
});
var IbmWatsonLanguageTranslator16 = /*#__PURE__*/React.forwardRef(function IbmWatsonLanguageTranslator16(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, _excluded87);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28h-3c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h3V28zM28 30h2.2l-4.6-11h-2.2l-4.6 11H21l.8-2h5.3L28 30zM22.7 26l1.8-4.4 1.8 4.4H22.7zM28 15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9 0 7 3.1 7 7V15zM14 5V3H9V1H7v2H2v2h8.2C10 5.9 9.4 7.5 8 9 7.4 8.3 6.9 7.6 6.6 7H4.3c.4 1 1.1 2.2 2.1 3.3C5.6 11 4.4 11.6 3 12.1L3.7 14c1.8-.7 3.2-1.5 4.3-2.3 1.1.9 2.5 1.7 4.3 2.3l.7-1.9c-1.4-.5-2.6-1.2-3.5-1.8 1.9-2 2.5-4.1 2.7-5.3H14z"
  })), children);
});
var IbmWatsonMachineLearning32 = /*#__PURE__*/React.forwardRef(function IbmWatsonMachineLearning32(_ref88, ref) {
  var children = _ref88.children,
      rest = _objectWithoutProperties(_ref88, _excluded88);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 22.5c-1-2-1.6-4.2-1.6-6.5C2 8.3 8.3 2 16 2v2C9.4 4 4 9.4 4 16c0 2 .5 3.8 1.4 5.5L3.6 22.5zM28 16c0 6.6-5.4 12-12 12-2.9 0-5.6-1-7.7-2.8l5.7-5.7L12.6 18l-6.5 6.5c-.4.4-.4 1 0 1.4C8.7 28.5 12.3 30 16 30c7.7 0 14-6.3 14-14H28z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2\tc0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7\tc-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5\tc0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z"
  })), children);
});
var IbmWatsonMachineLearning24 = /*#__PURE__*/React.forwardRef(function IbmWatsonMachineLearning24(_ref89, ref) {
  var children = _ref89.children,
      rest = _objectWithoutProperties(_ref89, _excluded89);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 22.5c-1-2-1.6-4.2-1.6-6.5C2 8.3 8.3 2 16 2v2C9.4 4 4 9.4 4 16c0 2 .5 3.8 1.4 5.5L3.6 22.5zM28 16c0 6.6-5.4 12-12 12-2.9 0-5.6-1-7.7-2.8l5.7-5.7L12.6 18l-6.5 6.5c-.4.4-.4 1 0 1.4C8.7 28.5 12.3 30 16 30c7.7 0 14-6.3 14-14H28z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2\tc0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7\tc-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5\tc0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z"
  })), children);
});
var IbmWatsonMachineLearning20 = /*#__PURE__*/React.forwardRef(function IbmWatsonMachineLearning20(_ref90, ref) {
  var children = _ref90.children,
      rest = _objectWithoutProperties(_ref90, _excluded90);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 22.5c-1-2-1.6-4.2-1.6-6.5C2 8.3 8.3 2 16 2v2C9.4 4 4 9.4 4 16c0 2 .5 3.8 1.4 5.5L3.6 22.5zM28 16c0 6.6-5.4 12-12 12-2.9 0-5.6-1-7.7-2.8l5.7-5.7L12.6 18l-6.5 6.5c-.4.4-.4 1 0 1.4C8.7 28.5 12.3 30 16 30c7.7 0 14-6.3 14-14H28z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2\tc0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7\tc-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5\tc0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z"
  })), children);
});
var IbmWatsonMachineLearning16 = /*#__PURE__*/React.forwardRef(function IbmWatsonMachineLearning16(_ref91, ref) {
  var children = _ref91.children,
      rest = _objectWithoutProperties(_ref91, _excluded91);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 22.5c-1-2-1.6-4.2-1.6-6.5C2 8.3 8.3 2 16 2v2C9.4 4 4 9.4 4 16c0 2 .5 3.8 1.4 5.5L3.6 22.5zM28 16c0 6.6-5.4 12-12 12-2.9 0-5.6-1-7.7-2.8l5.7-5.7L12.6 18l-6.5 6.5c-.4.4-.4 1 0 1.4C8.7 28.5 12.3 30 16 30c7.7 0 14-6.3 14-14H28z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2\tc0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7\tc-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5\tc0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z"
  })), children);
});
var IbmWatsonNaturalLanguageClassifier32 = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageClassifier32(_ref92, ref) {
  var children = _ref92.children,
      rest = _objectWithoutProperties(_ref92, _excluded92);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v4h-3v2h8v-2h-3v-4H28zM24 4h4v6h-4V4zM21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26zM12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16zM10 12V4c0-1.1-.9-2-2-2H3v2h5v2H4C2.9 6 2 6.9 2 8v2c0 1.1.9 2 2 2h1v4H2v2h8v-2H7v-4H10zM4 8h4v2H4V8z"
  })), children);
});
var IbmWatsonNaturalLanguageClassifier24 = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageClassifier24(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, _excluded93);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v4h-3v2h8v-2h-3v-4H28zM24 4h4v6h-4V4zM21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26zM12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16zM10 12V4c0-1.1-.9-2-2-2H3v2h5v2H4C2.9 6 2 6.9 2 8v2c0 1.1.9 2 2 2h1v4H2v2h8v-2H7v-4H10zM4 8h4v2H4V8z"
  })), children);
});
var IbmWatsonNaturalLanguageClassifier20 = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageClassifier20(_ref94, ref) {
  var children = _ref94.children,
      rest = _objectWithoutProperties(_ref94, _excluded94);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v4h-3v2h8v-2h-3v-4H28zM24 4h4v6h-4V4zM21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26zM12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16zM10 12V4c0-1.1-.9-2-2-2H3v2h5v2H4C2.9 6 2 6.9 2 8v2c0 1.1.9 2 2 2h1v4H2v2h8v-2H7v-4H10zM4 8h4v2H4V8z"
  })), children);
});
var IbmWatsonNaturalLanguageClassifier16 = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageClassifier16(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, _excluded95);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v4h-3v2h8v-2h-3v-4H28zM24 4h4v6h-4V4zM21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26zM12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16zM10 12V4c0-1.1-.9-2-2-2H3v2h5v2H4C2.9 6 2 6.9 2 8v2c0 1.1.9 2 2 2h1v4H2v2h8v-2H7v-4H10zM4 8h4v2H4V8z"
  })), children);
});
var IbmWatsonNaturalLanguageUnderstanding32 = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageUnderstanding32(_ref96, ref) {
  var children = _ref96.children,
      rest = _objectWithoutProperties(_ref96, _excluded96);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23H11V25H6zM6 19H11V21H6z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M13 30H4c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v11C15 29.1 14.1 30 13 30zM4 17v11h9V17H4zM19 2H27V4H19zM22 6H30V8H22zM22 10H30V12H22zM19 14H27V16H19zM22 18H30V20H22zM12 1l-1.4 1.4L13.2 5H4C2.9 5 2 5.9 2 7v5h2V7h9.2l-2.6 2.6L12 11l5-5L12 1z"
  })), children);
});
var IbmWatsonNaturalLanguageUnderstanding24 = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageUnderstanding24(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, _excluded97);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23H11V25H6zM6 19H11V21H6z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M13 30H4c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v11C15 29.1 14.1 30 13 30zM4 17v11h9V17H4zM19 2H27V4H19zM22 6H30V8H22zM22 10H30V12H22zM19 14H27V16H19zM22 18H30V20H22zM12 1l-1.4 1.4L13.2 5H4C2.9 5 2 5.9 2 7v5h2V7h9.2l-2.6 2.6L12 11l5-5L12 1z"
  })), children);
});
var IbmWatsonNaturalLanguageUnderstanding20 = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageUnderstanding20(_ref98, ref) {
  var children = _ref98.children,
      rest = _objectWithoutProperties(_ref98, _excluded98);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23H11V25H6zM6 19H11V21H6z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M13 30H4c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v11C15 29.1 14.1 30 13 30zM4 17v11h9V17H4zM19 2H27V4H19zM22 6H30V8H22zM22 10H30V12H22zM19 14H27V16H19zM22 18H30V20H22zM12 1l-1.4 1.4L13.2 5H4C2.9 5 2 5.9 2 7v5h2V7h9.2l-2.6 2.6L12 11l5-5L12 1z"
  })), children);
});
var IbmWatsonNaturalLanguageUnderstanding16 = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageUnderstanding16(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, _excluded99);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23H11V25H6zM6 19H11V21H6z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M13 30H4c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v11C15 29.1 14.1 30 13 30zM4 17v11h9V17H4zM19 2H27V4H19zM22 6H30V8H22zM22 10H30V12H22zM19 14H27V16H19zM22 18H30V20H22zM12 1l-1.4 1.4L13.2 5H4C2.9 5 2 5.9 2 7v5h2V7h9.2l-2.6 2.6L12 11l5-5L12 1z"
  })), children);
});
var IbmWatsonOpenscale32 = /*#__PURE__*/React.forwardRef(function IbmWatsonOpenscale32(_ref100, ref) {
  var children = _ref100.children,
      rest = _objectWithoutProperties(_ref100, _excluded100);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S5.7 28 4 28zM4 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S4.6 24 4 24zM28 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S29.7 28 28 28zM28 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S28.6 24 28 24zM22.4 4.4l-.9 1.8C26.1 8.4 29 13 29 18c0 .7-.1 1.4-.2 2.1l2 .3c.1-.8.2-1.6.2-2.5C31 12.2 27.6 6.9 22.4 4.4zM16 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S17.7 7 16 7zM16 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S16.6 3 16 3z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30\tc0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z"
  })), children);
});
var IbmWatsonOpenscale24 = /*#__PURE__*/React.forwardRef(function IbmWatsonOpenscale24(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, _excluded101);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S5.7 28 4 28zM4 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S4.6 24 4 24zM28 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S29.7 28 28 28zM28 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S28.6 24 28 24zM22.4 4.4l-.9 1.8C26.1 8.4 29 13 29 18c0 .7-.1 1.4-.2 2.1l2 .3c.1-.8.2-1.6.2-2.5C31 12.2 27.6 6.9 22.4 4.4zM16 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S17.7 7 16 7zM16 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S16.6 3 16 3z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30\tc0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z"
  })), children);
});
var IbmWatsonOpenscale20 = /*#__PURE__*/React.forwardRef(function IbmWatsonOpenscale20(_ref102, ref) {
  var children = _ref102.children,
      rest = _objectWithoutProperties(_ref102, _excluded102);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S5.7 28 4 28zM4 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S4.6 24 4 24zM28 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S29.7 28 28 28zM28 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S28.6 24 28 24zM22.4 4.4l-.9 1.8C26.1 8.4 29 13 29 18c0 .7-.1 1.4-.2 2.1l2 .3c.1-.8.2-1.6.2-2.5C31 12.2 27.6 6.9 22.4 4.4zM16 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S17.7 7 16 7zM16 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S16.6 3 16 3z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30\tc0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z"
  })), children);
});
var IbmWatsonOpenscale16 = /*#__PURE__*/React.forwardRef(function IbmWatsonOpenscale16(_ref103, ref) {
  var children = _ref103.children,
      rest = _objectWithoutProperties(_ref103, _excluded103);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S5.7 28 4 28zM4 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S4.6 24 4 24zM28 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S29.7 28 28 28zM28 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S28.6 24 28 24zM22.4 4.4l-.9 1.8C26.1 8.4 29 13 29 18c0 .7-.1 1.4-.2 2.1l2 .3c.1-.8.2-1.6.2-2.5C31 12.2 27.6 6.9 22.4 4.4zM16 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S17.7 7 16 7zM16 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S16.6 3 16 3z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30\tc0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z"
  })), children);
});
var IbmWatsonOrders32 = /*#__PURE__*/React.forwardRef(function IbmWatsonOrders32(_ref104, ref) {
  var children = _ref104.children,
      rest = _objectWithoutProperties(_ref104, _excluded104);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7V13zM22 20H25V22H22zM22 24H25V26H22z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12C29 29.1 28.1 30 27 30zM12 28h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1V28zM11 10v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4C2.9 2 2 2.9 2 4v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4V4h10v6H11z"
  })), children);
});
var IbmWatsonOrders24 = /*#__PURE__*/React.forwardRef(function IbmWatsonOrders24(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, _excluded105);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7V13zM22 20H25V22H22zM22 24H25V26H22z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12C29 29.1 28.1 30 27 30zM12 28h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1V28zM11 10v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4C2.9 2 2 2.9 2 4v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4V4h10v6H11z"
  })), children);
});
var IbmWatsonOrders20 = /*#__PURE__*/React.forwardRef(function IbmWatsonOrders20(_ref106, ref) {
  var children = _ref106.children,
      rest = _objectWithoutProperties(_ref106, _excluded106);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7V13zM22 20H25V22H22zM22 24H25V26H22z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12C29 29.1 28.1 30 27 30zM12 28h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1V28zM11 10v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4C2.9 2 2 2.9 2 4v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4V4h10v6H11z"
  })), children);
});
var IbmWatsonOrders16 = /*#__PURE__*/React.forwardRef(function IbmWatsonOrders16(_ref107, ref) {
  var children = _ref107.children,
      rest = _objectWithoutProperties(_ref107, _excluded107);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7V13zM22 20H25V22H22zM22 24H25V26H22z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12C29 29.1 28.1 30 27 30zM12 28h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1V28zM11 10v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4C2.9 2 2 2.9 2 4v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4V4h10v6H11z"
  })), children);
});
var IbmWatsonQuery32 = /*#__PURE__*/React.forwardRef(function IbmWatsonQuery32(_ref108, ref) {
  var children = _ref108.children,
      rest = _objectWithoutProperties(_ref108, _excluded108);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24\tc-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1\tc-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), children);
});
var IbmWatsonQuery24 = /*#__PURE__*/React.forwardRef(function IbmWatsonQuery24(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, _excluded109);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24\tc-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1\tc-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), children);
});
var IbmWatsonQuery20 = /*#__PURE__*/React.forwardRef(function IbmWatsonQuery20(_ref110, ref) {
  var children = _ref110.children,
      rest = _objectWithoutProperties(_ref110, _excluded110);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24\tc-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1\tc-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), children);
});
var IbmWatsonQuery16 = /*#__PURE__*/React.forwardRef(function IbmWatsonQuery16(_ref111, ref) {
  var children = _ref111.children,
      rest = _objectWithoutProperties(_ref111, _excluded111);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24\tc-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1\tc-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5\tc0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5\tc0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), children);
});
var IbmWatsonSpeechToText32 = /*#__PURE__*/React.forwardRef(function IbmWatsonSpeechToText32(_ref112, ref) {
  var children = _ref112.children,
      rest = _objectWithoutProperties(_ref112, _excluded112);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4v-6h10v6h-3v2h3c1.1 0 2-.9 2-2v-6C16 18.9 15.1 18 14 18zM19 26h2c3.9 0 7-3.1 7-7v-2h-2v2c0 2.8-2.2 5-5 5h-2V26zM18 11H24V13H18zM18 7H30V9H18zM18 3H30V5H18zM4 14h2v-2c0-2.8 2.2-5 5-5h4V5h-4c-3.9 0-7 3.1-7 7V14z"
  })), children);
});
var IbmWatsonSpeechToText24 = /*#__PURE__*/React.forwardRef(function IbmWatsonSpeechToText24(_ref113, ref) {
  var children = _ref113.children,
      rest = _objectWithoutProperties(_ref113, _excluded113);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4v-6h10v6h-3v2h3c1.1 0 2-.9 2-2v-6C16 18.9 15.1 18 14 18zM19 26h2c3.9 0 7-3.1 7-7v-2h-2v2c0 2.8-2.2 5-5 5h-2V26zM18 11H24V13H18zM18 7H30V9H18zM18 3H30V5H18zM4 14h2v-2c0-2.8 2.2-5 5-5h4V5h-4c-3.9 0-7 3.1-7 7V14z"
  })), children);
});
var IbmWatsonSpeechToText20 = /*#__PURE__*/React.forwardRef(function IbmWatsonSpeechToText20(_ref114, ref) {
  var children = _ref114.children,
      rest = _objectWithoutProperties(_ref114, _excluded114);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4v-6h10v6h-3v2h3c1.1 0 2-.9 2-2v-6C16 18.9 15.1 18 14 18zM19 26h2c3.9 0 7-3.1 7-7v-2h-2v2c0 2.8-2.2 5-5 5h-2V26zM18 11H24V13H18zM18 7H30V9H18zM18 3H30V5H18zM4 14h2v-2c0-2.8 2.2-5 5-5h4V5h-4c-3.9 0-7 3.1-7 7V14z"
  })), children);
});
var IbmWatsonSpeechToText16 = /*#__PURE__*/React.forwardRef(function IbmWatsonSpeechToText16(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, _excluded115);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4v-6h10v6h-3v2h3c1.1 0 2-.9 2-2v-6C16 18.9 15.1 18 14 18zM19 26h2c3.9 0 7-3.1 7-7v-2h-2v2c0 2.8-2.2 5-5 5h-2V26zM18 11H24V13H18zM18 7H30V9H18zM18 3H30V5H18zM4 14h2v-2c0-2.8 2.2-5 5-5h4V5h-4c-3.9 0-7 3.1-7 7V14z"
  })), children);
});
var IbmWatsonStudio32 = /*#__PURE__*/React.forwardRef(function IbmWatsonStudio32(_ref116, ref) {
  var children = _ref116.children,
      rest = _objectWithoutProperties(_ref116, _excluded116);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S27.8 21 25 21zM25 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3S26.7 13 25 13zM14 11V6c0-1.1-.9-2-2-2h-2v2h2v5c0 2.1 1.1 3.9 2.7 5-1.6 1.1-2.7 2.9-2.7 5v5h-2v2h2c1.1 0 2-.9 2-2v-5c0-2.2 1.8-4 4-4v-2C15.8 15 14 13.2 14 11zM2 30v-6h6v6H2zM4 26v2h2v-2H4zM2 19v-6h6v6H2zM4 15v2h2v-2H4zM2 8V2h6v6H2zM4 4v2h2V4H4z"
  })), children);
});
var IbmWatsonStudio24 = /*#__PURE__*/React.forwardRef(function IbmWatsonStudio24(_ref117, ref) {
  var children = _ref117.children,
      rest = _objectWithoutProperties(_ref117, _excluded117);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S27.8 21 25 21zM25 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3S26.7 13 25 13zM14 11V6c0-1.1-.9-2-2-2h-2v2h2v5c0 2.1 1.1 3.9 2.7 5-1.6 1.1-2.7 2.9-2.7 5v5h-2v2h2c1.1 0 2-.9 2-2v-5c0-2.2 1.8-4 4-4v-2C15.8 15 14 13.2 14 11zM2 30v-6h6v6H2zM4 26v2h2v-2H4zM2 19v-6h6v6H2zM4 15v2h2v-2H4zM2 8V2h6v6H2zM4 4v2h2V4H4z"
  })), children);
});
var IbmWatsonStudio20 = /*#__PURE__*/React.forwardRef(function IbmWatsonStudio20(_ref118, ref) {
  var children = _ref118.children,
      rest = _objectWithoutProperties(_ref118, _excluded118);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S27.8 21 25 21zM25 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3S26.7 13 25 13zM14 11V6c0-1.1-.9-2-2-2h-2v2h2v5c0 2.1 1.1 3.9 2.7 5-1.6 1.1-2.7 2.9-2.7 5v5h-2v2h2c1.1 0 2-.9 2-2v-5c0-2.2 1.8-4 4-4v-2C15.8 15 14 13.2 14 11zM2 30v-6h6v6H2zM4 26v2h2v-2H4zM2 19v-6h6v6H2zM4 15v2h2v-2H4zM2 8V2h6v6H2zM4 4v2h2V4H4z"
  })), children);
});
var IbmWatsonStudio16 = /*#__PURE__*/React.forwardRef(function IbmWatsonStudio16(_ref119, ref) {
  var children = _ref119.children,
      rest = _objectWithoutProperties(_ref119, _excluded119);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S27.8 21 25 21zM25 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3S26.7 13 25 13zM14 11V6c0-1.1-.9-2-2-2h-2v2h2v5c0 2.1 1.1 3.9 2.7 5-1.6 1.1-2.7 2.9-2.7 5v5h-2v2h2c1.1 0 2-.9 2-2v-5c0-2.2 1.8-4 4-4v-2C15.8 15 14 13.2 14 11zM2 30v-6h6v6H2zM4 26v2h2v-2H4zM2 19v-6h6v6H2zM4 15v2h2v-2H4zM2 8V2h6v6H2zM4 4v2h2V4H4z"
  })), children);
});
var IbmWatsonTextToSpeech32 = /*#__PURE__*/React.forwardRef(function IbmWatsonTextToSpeech32(_ref120, ref) {
  var children = _ref120.children,
      rest = _objectWithoutProperties(_ref120, _excluded120);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26h-2c-3.9 0-7-3.1-7-7v-2h2v2c0 2.8 2.2 5 5 5h2V26zM18 18h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3-1.7-1 2.3-4H28v-6H18v6h3v2h-3c-1.1 0-2-.9-2-2v-6C16 18.9 16.9 18 18 18zM28 14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9 0 7 3.1 7 7V14zM2 11H8V13H2zM2 7H14V9H2zM2 3H14V5H2z"
  })), children);
});
var IbmWatsonTextToSpeech24 = /*#__PURE__*/React.forwardRef(function IbmWatsonTextToSpeech24(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, _excluded121);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26h-2c-3.9 0-7-3.1-7-7v-2h2v2c0 2.8 2.2 5 5 5h2V26zM18 18h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3-1.7-1 2.3-4H28v-6H18v6h3v2h-3c-1.1 0-2-.9-2-2v-6C16 18.9 16.9 18 18 18zM28 14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9 0 7 3.1 7 7V14zM2 11H8V13H2zM2 7H14V9H2zM2 3H14V5H2z"
  })), children);
});
var IbmWatsonTextToSpeech20 = /*#__PURE__*/React.forwardRef(function IbmWatsonTextToSpeech20(_ref122, ref) {
  var children = _ref122.children,
      rest = _objectWithoutProperties(_ref122, _excluded122);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26h-2c-3.9 0-7-3.1-7-7v-2h2v2c0 2.8 2.2 5 5 5h2V26zM18 18h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3-1.7-1 2.3-4H28v-6H18v6h3v2h-3c-1.1 0-2-.9-2-2v-6C16 18.9 16.9 18 18 18zM28 14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9 0 7 3.1 7 7V14zM2 11H8V13H2zM2 7H14V9H2zM2 3H14V5H2z"
  })), children);
});
var IbmWatsonTextToSpeech16 = /*#__PURE__*/React.forwardRef(function IbmWatsonTextToSpeech16(_ref123, ref) {
  var children = _ref123.children,
      rest = _objectWithoutProperties(_ref123, _excluded123);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26h-2c-3.9 0-7-3.1-7-7v-2h2v2c0 2.8 2.2 5 5 5h2V26zM18 18h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3-1.7-1 2.3-4H28v-6H18v6h3v2h-3c-1.1 0-2-.9-2-2v-6C16 18.9 16.9 18 18 18zM28 14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9 0 7 3.1 7 7V14zM2 11H8V13H2zM2 7H14V9H2zM2 3H14V5H2z"
  })), children);
});
var IbmWatsonToneAnalyzer32 = /*#__PURE__*/React.forwardRef(function IbmWatsonToneAnalyzer32(_ref124, ref) {
  var children = _ref124.children,
      rest = _objectWithoutProperties(_ref124, _excluded124);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "1"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "5",
    r: "1"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0l13 0c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3.5l-1.7 3L21 16l2.3-4H28V2H15v10h5v2h-5c-1.1 0-2-.9-2-2V2C13 .9 13.9 0 15 0zM20 19v6c0 .6-.4 1-1 1h-5v2h5c1.7 0 3-1.3 3-3v-6H20zM15.4 20.4c-.8 1-2.1 1.6-3.4 1.6s-2.6-.6-3.4-1.6L7 21.6c1.2 1.4 3 2.4 5 2.4s3.8-.9 5-2.4L15.4 20.4z"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: "15.5",
    cy: "17.5",
    r: "1.5"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: "8.5",
    cy: "17.5",
    r: "1.5"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z"
  })), children);
});
var IbmWatsonToneAnalyzer24 = /*#__PURE__*/React.forwardRef(function IbmWatsonToneAnalyzer24(_ref125, ref) {
  var children = _ref125.children,
      rest = _objectWithoutProperties(_ref125, _excluded125);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "1"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "5",
    r: "1"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0l13 0c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3.5l-1.7 3L21 16l2.3-4H28V2H15v10h5v2h-5c-1.1 0-2-.9-2-2V2C13 .9 13.9 0 15 0zM20 19v6c0 .6-.4 1-1 1h-5v2h5c1.7 0 3-1.3 3-3v-6H20zM15.4 20.4c-.8 1-2.1 1.6-3.4 1.6s-2.6-.6-3.4-1.6L7 21.6c1.2 1.4 3 2.4 5 2.4s3.8-.9 5-2.4L15.4 20.4z"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: "15.5",
    cy: "17.5",
    r: "1.5"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: "8.5",
    cy: "17.5",
    r: "1.5"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z"
  })), children);
});
var IbmWatsonToneAnalyzer20 = /*#__PURE__*/React.forwardRef(function IbmWatsonToneAnalyzer20(_ref126, ref) {
  var children = _ref126.children,
      rest = _objectWithoutProperties(_ref126, _excluded126);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "1"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "5",
    r: "1"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0l13 0c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3.5l-1.7 3L21 16l2.3-4H28V2H15v10h5v2h-5c-1.1 0-2-.9-2-2V2C13 .9 13.9 0 15 0zM20 19v6c0 .6-.4 1-1 1h-5v2h5c1.7 0 3-1.3 3-3v-6H20zM15.4 20.4c-.8 1-2.1 1.6-3.4 1.6s-2.6-.6-3.4-1.6L7 21.6c1.2 1.4 3 2.4 5 2.4s3.8-.9 5-2.4L15.4 20.4z"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: "15.5",
    cy: "17.5",
    r: "1.5"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: "8.5",
    cy: "17.5",
    r: "1.5"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z"
  })), children);
});
var IbmWatsonToneAnalyzer16 = /*#__PURE__*/React.forwardRef(function IbmWatsonToneAnalyzer16(_ref127, ref) {
  var children = _ref127.children,
      rest = _objectWithoutProperties(_ref127, _excluded127);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "1"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "5",
    r: "1"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0l13 0c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3.5l-1.7 3L21 16l2.3-4H28V2H15v10h5v2h-5c-1.1 0-2-.9-2-2V2C13 .9 13.9 0 15 0zM20 19v6c0 .6-.4 1-1 1h-5v2h5c1.7 0 3-1.3 3-3v-6H20zM15.4 20.4c-.8 1-2.1 1.6-3.4 1.6s-2.6-.6-3.4-1.6L7 21.6c1.2 1.4 3 2.4 5 2.4s3.8-.9 5-2.4L15.4 20.4z"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: "15.5",
    cy: "17.5",
    r: "1.5"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: "8.5",
    cy: "17.5",
    r: "1.5"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z"
  })), children);
});
var IbmWatsonxAssistant32 = /*#__PURE__*/React.forwardRef(function IbmWatsonxAssistant32(_ref128, ref) {
  var children = _ref128.children,
      rest = _objectWithoutProperties(_ref128, _excluded128);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2h-10c-1.1035 0-2 .8965-2 2v6c0 1.1035.8965 2 2 2h2.4229s1.7314 3 1.7314 3l1.7324-1-2.3096-4h-3.5771V4h10v6h-3s0 2 0 2h3c1.1035 0 2-.8965 2-2V4c0-1.1035-.8965-2-2-2zM14.6904 31l-1.7324-1 3.4648-6h5.5771c1.1046 0 2-.8954 2-2v-5h2v5c0 2.2091-1.7909 4-4 4h-4.4229l-2.8867 5z"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "m12,26h-6c-2.2091,0-4-1.7909-4-4v-10c0-2.2091,1.7909-4,4-4h8v2H6c-1.1046,0-2,.8954-2,2v10c0,1.1046.8954,2,2,2h6v2Z"
  })), children);
});
var IbmWatsonxAssistant24 = /*#__PURE__*/React.forwardRef(function IbmWatsonxAssistant24(_ref129, ref) {
  var children = _ref129.children,
      rest = _objectWithoutProperties(_ref129, _excluded129);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2h-10c-1.1035 0-2 .8965-2 2v6c0 1.1035.8965 2 2 2h2.4229s1.7314 3 1.7314 3l1.7324-1-2.3096-4h-3.5771V4h10v6h-3s0 2 0 2h3c1.1035 0 2-.8965 2-2V4c0-1.1035-.8965-2-2-2zM14.6904 31l-1.7324-1 3.4648-6h5.5771c1.1046 0 2-.8954 2-2v-5h2v5c0 2.2091-1.7909 4-4 4h-4.4229l-2.8867 5z"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "m12,26h-6c-2.2091,0-4-1.7909-4-4v-10c0-2.2091,1.7909-4,4-4h8v2H6c-1.1046,0-2,.8954-2,2v10c0,1.1046.8954,2,2,2h6v2Z"
  })), children);
});
var IbmWatsonxAssistant20 = /*#__PURE__*/React.forwardRef(function IbmWatsonxAssistant20(_ref130, ref) {
  var children = _ref130.children,
      rest = _objectWithoutProperties(_ref130, _excluded130);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2h-10c-1.1035 0-2 .8965-2 2v6c0 1.1035.8965 2 2 2h2.4229s1.7314 3 1.7314 3l1.7324-1-2.3096-4h-3.5771V4h10v6h-3s0 2 0 2h3c1.1035 0 2-.8965 2-2V4c0-1.1035-.8965-2-2-2zM14.6904 31l-1.7324-1 3.4648-6h5.5771c1.1046 0 2-.8954 2-2v-5h2v5c0 2.2091-1.7909 4-4 4h-4.4229l-2.8867 5z"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "m12,26h-6c-2.2091,0-4-1.7909-4-4v-10c0-2.2091,1.7909-4,4-4h8v2H6c-1.1046,0-2,.8954-2,2v10c0,1.1046.8954,2,2,2h6v2Z"
  })), children);
});
var IbmWatsonxAssistant16 = /*#__PURE__*/React.forwardRef(function IbmWatsonxAssistant16(_ref131, ref) {
  var children = _ref131.children,
      rest = _objectWithoutProperties(_ref131, _excluded131);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2h-10c-1.1035 0-2 .8965-2 2v6c0 1.1035.8965 2 2 2h2.4229s1.7314 3 1.7314 3l1.7324-1-2.3096-4h-3.5771V4h10v6h-3s0 2 0 2h3c1.1035 0 2-.8965 2-2V4c0-1.1035-.8965-2-2-2zM14.6904 31l-1.7324-1 3.4648-6h5.5771c1.1046 0 2-.8954 2-2v-5h2v5c0 2.2091-1.7909 4-4 4h-4.4229l-2.8867 5z"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "m12,26h-6c-2.2091,0-4-1.7909-4-4v-10c0-2.2091,1.7909-4,4-4h8v2H6c-1.1046,0-2,.8954-2,2v10c0,1.1046.8954,2,2,2h6v2Z"
  })), children);
});
var IbmWatsonxCodeAssistant32 = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistant32(_ref132, ref) {
  var children = _ref132.children,
      rest = _objectWithoutProperties(_ref132, _excluded132);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28h-2c-3.8599 0-7-3.1401-7-7v-2h2v2c0 2.7568 2.2432 5 5 5h2v2zM28.17 26L25.59 28.58 27 30 31 26 27 22 25.58 23.41 28.17 26zM22 31L20.085 30.4229 23 21 24.9149 21.5771 22 31zM16.83 26L19.41 23.42 18 22 14 26 18 30 19.42 28.59 16.83 26zM30 19h-2v-7c0-2.7614-2.2386-5-5-5h-4v-2h4c3.866 0 7 3.134 7 7v7z"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "4",
    r: "1"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H16V5H6z"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "12",
    r: "1"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H16V13H6zM2 15H12V17H2z"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "8",
    r: "1"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H12V9H2z"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "16",
    r: "1"
  })), children);
});
var IbmWatsonxCodeAssistant24 = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistant24(_ref133, ref) {
  var children = _ref133.children,
      rest = _objectWithoutProperties(_ref133, _excluded133);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28h-2c-3.8599 0-7-3.1401-7-7v-2h2v2c0 2.7568 2.2432 5 5 5h2v2zM28.17 26L25.59 28.58 27 30 31 26 27 22 25.58 23.41 28.17 26zM22 31L20.085 30.4229 23 21 24.9149 21.5771 22 31zM16.83 26L19.41 23.42 18 22 14 26 18 30 19.42 28.59 16.83 26zM30 19h-2v-7c0-2.7614-2.2386-5-5-5h-4v-2h4c3.866 0 7 3.134 7 7v7z"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "4",
    r: "1"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H16V5H6z"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "12",
    r: "1"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H16V13H6zM2 15H12V17H2z"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "8",
    r: "1"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H12V9H2z"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "16",
    r: "1"
  })), children);
});
var IbmWatsonxCodeAssistant20 = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistant20(_ref134, ref) {
  var children = _ref134.children,
      rest = _objectWithoutProperties(_ref134, _excluded134);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28h-2c-3.8599 0-7-3.1401-7-7v-2h2v2c0 2.7568 2.2432 5 5 5h2v2zM28.17 26L25.59 28.58 27 30 31 26 27 22 25.58 23.41 28.17 26zM22 31L20.085 30.4229 23 21 24.9149 21.5771 22 31zM16.83 26L19.41 23.42 18 22 14 26 18 30 19.42 28.59 16.83 26zM30 19h-2v-7c0-2.7614-2.2386-5-5-5h-4v-2h4c3.866 0 7 3.134 7 7v7z"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "4",
    r: "1"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H16V5H6z"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "12",
    r: "1"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H16V13H6zM2 15H12V17H2z"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "8",
    r: "1"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H12V9H2z"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "16",
    r: "1"
  })), children);
});
var IbmWatsonxCodeAssistant16 = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistant16(_ref135, ref) {
  var children = _ref135.children,
      rest = _objectWithoutProperties(_ref135, _excluded135);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28h-2c-3.8599 0-7-3.1401-7-7v-2h2v2c0 2.7568 2.2432 5 5 5h2v2zM28.17 26L25.59 28.58 27 30 31 26 27 22 25.58 23.41 28.17 26zM22 31L20.085 30.4229 23 21 24.9149 21.5771 22 31zM16.83 26L19.41 23.42 18 22 14 26 18 30 19.42 28.59 16.83 26zM30 19h-2v-7c0-2.7614-2.2386-5-5-5h-4v-2h4c3.866 0 7 3.134 7 7v7z"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "4",
    r: "1"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H16V5H6z"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "12",
    r: "1"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H16V13H6zM2 15H12V17H2z"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "8",
    r: "1"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H12V9H2z"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "16",
    r: "1"
  })), children);
});
var IbmWatsonxCodeAssistantForZ32 = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistantForZ32(_ref136, ref) {
  var children = _ref136.children,
      rest = _objectWithoutProperties(_ref136, _excluded136);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M29.17 25L26.59 27.58 28 29 32 25 28 21 26.58 22.41 29.17 25zM23 30L21.0851 29.4229 24 20 25.9149 20.5771 23 30zM17.83 25L20.41 22.42 19 21 15 25 19 29 20.42 27.59 17.83 25zM18 19h-2V5c0-1.1028.8972-2 2-2h9c1.1028 0 2 .8972 2 2v11h-2V5h-9v14zM12 3H3c-1.1028 0-2 .8975-2 2v22c0 1.1025.8972 2 2 2h9c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 7.0366l-6.925-5.0366h6.9248l.0002 5.0366zm-.7004 1.9634l-8.2998 6.0361V5.9639l8.2998 6.0361zm.7007 1.9634l.0007 11.8169-8.2795-5.7959 8.2788-6.021zm-9.0005 7.9575l7.2563 5.0791H3v-5.0791zm9 5.0791l.0012-.002v.002h-.0012z"
  })), children);
});
var IbmWatsonxCodeAssistantForZ24 = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistantForZ24(_ref137, ref) {
  var children = _ref137.children,
      rest = _objectWithoutProperties(_ref137, _excluded137);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M29.17 25L26.59 27.58 28 29 32 25 28 21 26.58 22.41 29.17 25zM23 30L21.0851 29.4229 24 20 25.9149 20.5771 23 30zM17.83 25L20.41 22.42 19 21 15 25 19 29 20.42 27.59 17.83 25zM18 19h-2V5c0-1.1028.8972-2 2-2h9c1.1028 0 2 .8972 2 2v11h-2V5h-9v14zM12 3H3c-1.1028 0-2 .8975-2 2v22c0 1.1025.8972 2 2 2h9c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 7.0366l-6.925-5.0366h6.9248l.0002 5.0366zm-.7004 1.9634l-8.2998 6.0361V5.9639l8.2998 6.0361zm.7007 1.9634l.0007 11.8169-8.2795-5.7959 8.2788-6.021zm-9.0005 7.9575l7.2563 5.0791H3v-5.0791zm9 5.0791l.0012-.002v.002h-.0012z"
  })), children);
});
var IbmWatsonxCodeAssistantForZ20 = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistantForZ20(_ref138, ref) {
  var children = _ref138.children,
      rest = _objectWithoutProperties(_ref138, _excluded138);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M29.17 25L26.59 27.58 28 29 32 25 28 21 26.58 22.41 29.17 25zM23 30L21.0851 29.4229 24 20 25.9149 20.5771 23 30zM17.83 25L20.41 22.42 19 21 15 25 19 29 20.42 27.59 17.83 25zM18 19h-2V5c0-1.1028.8972-2 2-2h9c1.1028 0 2 .8972 2 2v11h-2V5h-9v14zM12 3H3c-1.1028 0-2 .8975-2 2v22c0 1.1025.8972 2 2 2h9c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 7.0366l-6.925-5.0366h6.9248l.0002 5.0366zm-.7004 1.9634l-8.2998 6.0361V5.9639l8.2998 6.0361zm.7007 1.9634l.0007 11.8169-8.2795-5.7959 8.2788-6.021zm-9.0005 7.9575l7.2563 5.0791H3v-5.0791zm9 5.0791l.0012-.002v.002h-.0012z"
  })), children);
});
var IbmWatsonxCodeAssistantForZ16 = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistantForZ16(_ref139, ref) {
  var children = _ref139.children,
      rest = _objectWithoutProperties(_ref139, _excluded139);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M29.17 25L26.59 27.58 28 29 32 25 28 21 26.58 22.41 29.17 25zM23 30L21.0851 29.4229 24 20 25.9149 20.5771 23 30zM17.83 25L20.41 22.42 19 21 15 25 19 29 20.42 27.59 17.83 25zM18 19h-2V5c0-1.1028.8972-2 2-2h9c1.1028 0 2 .8972 2 2v11h-2V5h-9v14zM12 3H3c-1.1028 0-2 .8975-2 2v22c0 1.1025.8972 2 2 2h9c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 7.0366l-6.925-5.0366h6.9248l.0002 5.0366zm-.7004 1.9634l-8.2998 6.0361V5.9639l8.2998 6.0361zm.7007 1.9634l.0007 11.8169-8.2795-5.7959 8.2788-6.021zm-9.0005 7.9575l7.2563 5.0791H3v-5.0791zm9 5.0791l.0012-.002v.002h-.0012z"
  })), children);
});
var IbmWatsonxCodeAssistantForZRefactor32 = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistantForZRefactor32(_ref140, ref) {
  var children = _ref140.children,
      rest = _objectWithoutProperties(_ref140, _excluded140);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M22.17 16L19.59 18.58 21 20 25 16 21 12 19.58 13.41 22.17 16zM15.5 21L13.5851 20.4229 16.5 11 18.4149 11.5771 15.5 21zM9.83 16L12.41 13.42 11 12 7 16 11 20 12.42 18.59 9.83 16z"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "28",
    r: "1"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "m22,29v-2c2.7568,0,5-2.2432,5-5v-12c0-2.7568-2.2432-5-5-5h-6v-2h6c3.8594,0,7,3.1401,7,7v12c0,3.8594-3.1406,7-7,7Z"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "4",
    r: "1"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "m16,29h-6c-3.8594,0-7-3.1406-7-7v-12c0-3.8599,3.1406-7,7-7v2c-2.7568,0-5,2.2432-5,5v12c0,2.7568,2.2432,5,5,5h6v2Z"
  })), children);
});
var IbmWatsonxCodeAssistantForZRefactor24 = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistantForZRefactor24(_ref141, ref) {
  var children = _ref141.children,
      rest = _objectWithoutProperties(_ref141, _excluded141);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M22.17 16L19.59 18.58 21 20 25 16 21 12 19.58 13.41 22.17 16zM15.5 21L13.5851 20.4229 16.5 11 18.4149 11.5771 15.5 21zM9.83 16L12.41 13.42 11 12 7 16 11 20 12.42 18.59 9.83 16z"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "28",
    r: "1"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "m22,29v-2c2.7568,0,5-2.2432,5-5v-12c0-2.7568-2.2432-5-5-5h-6v-2h6c3.8594,0,7,3.1401,7,7v12c0,3.8594-3.1406,7-7,7Z"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "4",
    r: "1"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "m16,29h-6c-3.8594,0-7-3.1406-7-7v-12c0-3.8599,3.1406-7,7-7v2c-2.7568,0-5,2.2432-5,5v12c0,2.7568,2.2432,5,5,5h6v2Z"
  })), children);
});
var IbmWatsonxCodeAssistantForZRefactor20 = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistantForZRefactor20(_ref142, ref) {
  var children = _ref142.children,
      rest = _objectWithoutProperties(_ref142, _excluded142);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M22.17 16L19.59 18.58 21 20 25 16 21 12 19.58 13.41 22.17 16zM15.5 21L13.5851 20.4229 16.5 11 18.4149 11.5771 15.5 21zM9.83 16L12.41 13.42 11 12 7 16 11 20 12.42 18.59 9.83 16z"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "28",
    r: "1"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "m22,29v-2c2.7568,0,5-2.2432,5-5v-12c0-2.7568-2.2432-5-5-5h-6v-2h6c3.8594,0,7,3.1401,7,7v12c0,3.8594-3.1406,7-7,7Z"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "4",
    r: "1"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "m16,29h-6c-3.8594,0-7-3.1406-7-7v-12c0-3.8599,3.1406-7,7-7v2c-2.7568,0-5,2.2432-5,5v12c0,2.7568,2.2432,5,5,5h6v2Z"
  })), children);
});
var IbmWatsonxCodeAssistantForZRefactor16 = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistantForZRefactor16(_ref143, ref) {
  var children = _ref143.children,
      rest = _objectWithoutProperties(_ref143, _excluded143);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M22.17 16L19.59 18.58 21 20 25 16 21 12 19.58 13.41 22.17 16zM15.5 21L13.5851 20.4229 16.5 11 18.4149 11.5771 15.5 21zM9.83 16L12.41 13.42 11 12 7 16 11 20 12.42 18.59 9.83 16z"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "28",
    r: "1"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "m22,29v-2c2.7568,0,5-2.2432,5-5v-12c0-2.7568-2.2432-5-5-5h-6v-2h6c3.8594,0,7,3.1401,7,7v12c0,3.8594-3.1406,7-7,7Z"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "4",
    r: "1"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "m16,29h-6c-3.8594,0-7-3.1406-7-7v-12c0-3.8599,3.1406-7,7-7v2c-2.7568,0-5,2.2432-5,5v12c0,2.7568,2.2432,5,5,5h6v2Z"
  })), children);
});
var IbmWatsonxOrchestrate32 = /*#__PURE__*/React.forwardRef(function IbmWatsonxOrchestrate32(_ref144, ref) {
  var children = _ref144.children,
      rest = _objectWithoutProperties(_ref144, _excluded144);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "m27.9248,19.4282c-1.123,1.6104-2.9641,2.5718-4.9248,2.5718-2.1233,0-4.0464-1.0874-5.1438-2.9092l-1.7129,1.0322c1.4624,2.4277,4.0256,3.877,6.8567,3.877,1.4231,0,2.7925-.3911,3.9922-1.0835-2.3442,3.6958-6.4814,6.0835-10.9922,6.0835-5.7104,0-10.8347-3.8184-12.4617-9.2852l-1.917.5703c1.8774,6.3086,7.79,10.7148,14.3787,10.7148s12.5012-4.4062,14.3787-10.7148l-2.4539-.8569Z"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "16",
    r: "2"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "16",
    r: "2"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1C9.4114,1,3.4988,5.4062,1.6213,11.7148l2.4539.8569c1.123-1.6104,2.9641-2.5718,4.9248-2.5718s3.8018.9614,4.9248,2.5718l1.6406-1.144c-1.4971-2.1465-3.9514-3.4277-6.5654-3.4277-1.4231,0-2.7925.3911-3.9922,1.0835,2.3442-3.6953,6.4814-6.0835,10.9922-6.0835,5.7104,0,10.8347,3.8184,12.4617,9.2852l1.917-.5703c-1.8774-6.3086-7.79-10.7148-14.3787-10.7148Z"
  })), children);
});
var IbmWatsonxOrchestrate24 = /*#__PURE__*/React.forwardRef(function IbmWatsonxOrchestrate24(_ref145, ref) {
  var children = _ref145.children,
      rest = _objectWithoutProperties(_ref145, _excluded145);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "m27.9248,19.4282c-1.123,1.6104-2.9641,2.5718-4.9248,2.5718-2.1233,0-4.0464-1.0874-5.1438-2.9092l-1.7129,1.0322c1.4624,2.4277,4.0256,3.877,6.8567,3.877,1.4231,0,2.7925-.3911,3.9922-1.0835-2.3442,3.6958-6.4814,6.0835-10.9922,6.0835-5.7104,0-10.8347-3.8184-12.4617-9.2852l-1.917.5703c1.8774,6.3086,7.79,10.7148,14.3787,10.7148s12.5012-4.4062,14.3787-10.7148l-2.4539-.8569Z"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "16",
    r: "2"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "16",
    r: "2"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1C9.4114,1,3.4988,5.4062,1.6213,11.7148l2.4539.8569c1.123-1.6104,2.9641-2.5718,4.9248-2.5718s3.8018.9614,4.9248,2.5718l1.6406-1.144c-1.4971-2.1465-3.9514-3.4277-6.5654-3.4277-1.4231,0-2.7925.3911-3.9922,1.0835,2.3442-3.6953,6.4814-6.0835,10.9922-6.0835,5.7104,0,10.8347,3.8184,12.4617,9.2852l1.917-.5703c-1.8774-6.3086-7.79-10.7148-14.3787-10.7148Z"
  })), children);
});
var IbmWatsonxOrchestrate20 = /*#__PURE__*/React.forwardRef(function IbmWatsonxOrchestrate20(_ref146, ref) {
  var children = _ref146.children,
      rest = _objectWithoutProperties(_ref146, _excluded146);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "m27.9248,19.4282c-1.123,1.6104-2.9641,2.5718-4.9248,2.5718-2.1233,0-4.0464-1.0874-5.1438-2.9092l-1.7129,1.0322c1.4624,2.4277,4.0256,3.877,6.8567,3.877,1.4231,0,2.7925-.3911,3.9922-1.0835-2.3442,3.6958-6.4814,6.0835-10.9922,6.0835-5.7104,0-10.8347-3.8184-12.4617-9.2852l-1.917.5703c1.8774,6.3086,7.79,10.7148,14.3787,10.7148s12.5012-4.4062,14.3787-10.7148l-2.4539-.8569Z"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "16",
    r: "2"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "16",
    r: "2"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1C9.4114,1,3.4988,5.4062,1.6213,11.7148l2.4539.8569c1.123-1.6104,2.9641-2.5718,4.9248-2.5718s3.8018.9614,4.9248,2.5718l1.6406-1.144c-1.4971-2.1465-3.9514-3.4277-6.5654-3.4277-1.4231,0-2.7925.3911-3.9922,1.0835,2.3442-3.6953,6.4814-6.0835,10.9922-6.0835,5.7104,0,10.8347,3.8184,12.4617,9.2852l1.917-.5703c-1.8774-6.3086-7.79-10.7148-14.3787-10.7148Z"
  })), children);
});
var IbmWatsonxOrchestrate16 = /*#__PURE__*/React.forwardRef(function IbmWatsonxOrchestrate16(_ref147, ref) {
  var children = _ref147.children,
      rest = _objectWithoutProperties(_ref147, _excluded147);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "m27.9248,19.4282c-1.123,1.6104-2.9641,2.5718-4.9248,2.5718-2.1233,0-4.0464-1.0874-5.1438-2.9092l-1.7129,1.0322c1.4624,2.4277,4.0256,3.877,6.8567,3.877,1.4231,0,2.7925-.3911,3.9922-1.0835-2.3442,3.6958-6.4814,6.0835-10.9922,6.0835-5.7104,0-10.8347-3.8184-12.4617-9.2852l-1.917.5703c1.8774,6.3086,7.79,10.7148,14.3787,10.7148s12.5012-4.4062,14.3787-10.7148l-2.4539-.8569Z"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "16",
    r: "2"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "16",
    r: "2"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1C9.4114,1,3.4988,5.4062,1.6213,11.7148l2.4539.8569c1.123-1.6104,2.9641-2.5718,4.9248-2.5718s3.8018.9614,4.9248,2.5718l1.6406-1.144c-1.4971-2.1465-3.9514-3.4277-6.5654-3.4277-1.4231,0-2.7925.3911-3.9922,1.0835,2.3442-3.6953,6.4814-6.0835,10.9922-6.0835,5.7104,0,10.8347,3.8184,12.4617,9.2852l1.917-.5703c-1.8774-6.3086-7.79-10.7148-14.3787-10.7148Z"
  })), children);
});
var IbmZCloudModStack32 = /*#__PURE__*/React.forwardRef(function IbmZCloudModStack32(_ref148, ref) {
  var children = _ref148.children,
      rest = _objectWithoutProperties(_ref148, _excluded148);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2\ts-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7\tC15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19\tc0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137\tc0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7\tC3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2\tC24,18.262,23.595,17.624,23,17.277z"
  })), children);
});
var IbmZCloudModStack24 = /*#__PURE__*/React.forwardRef(function IbmZCloudModStack24(_ref149, ref) {
  var children = _ref149.children,
      rest = _objectWithoutProperties(_ref149, _excluded149);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2\ts-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7\tC15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19\tc0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137\tc0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7\tC3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2\tC24,18.262,23.595,17.624,23,17.277z"
  })), children);
});
var IbmZCloudModStack20 = /*#__PURE__*/React.forwardRef(function IbmZCloudModStack20(_ref150, ref) {
  var children = _ref150.children,
      rest = _objectWithoutProperties(_ref150, _excluded150);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2\ts-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7\tC15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19\tc0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137\tc0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7\tC3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2\tC24,18.262,23.595,17.624,23,17.277z"
  })), children);
});
var IbmZCloudModStack16 = /*#__PURE__*/React.forwardRef(function IbmZCloudModStack16(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, _excluded151);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2\ts-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7\tC15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19\tc0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137\tc0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7\tC3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2\tC24,18.262,23.595,17.624,23,17.277z"
  })), children);
});
var IbmZEnvironmentsDevSecOps32 = /*#__PURE__*/React.forwardRef(function IbmZEnvironmentsDevSecOps32(_ref152, ref) {
  var children = _ref152.children,
      rest = _objectWithoutProperties(_ref152, _excluded152);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "m23.5,16v2c3.0327,0,5.5,2.4673,5.5,5.5s-2.4673,5.5-5.5,5.5-5.5-2.4673-5.5-5.5h-2c0,4.1422,3.3578,7.5,7.5,7.5s7.5-3.3578,7.5-7.5-3.3578-7.5-7.5-7.5Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 26c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5c-.3217 0-.6268.066-.9093.1766l-4.8837-4.8837-1.4141 1.4141 4.8837 4.8837c-.1107.2825-.1766.5876-.1766.9093 0 1.3807 1.1193 2.5 2.5 2.5zM29 13h-2v-3.4257l-11-6.4166-3 1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12 7c.3071.1792.4961.5081.4961.8638v4zM7 6H9V16H7z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "m13.9998,29.991l-10.5037-6.1272c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l10.0076,5.8378-1.0078,1.7275Z"
  })), children);
});
var IbmZEnvironmentsDevSecOps24 = /*#__PURE__*/React.forwardRef(function IbmZEnvironmentsDevSecOps24(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, _excluded153);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "m23.5,16v2c3.0327,0,5.5,2.4673,5.5,5.5s-2.4673,5.5-5.5,5.5-5.5-2.4673-5.5-5.5h-2c0,4.1422,3.3578,7.5,7.5,7.5s7.5-3.3578,7.5-7.5-3.3578-7.5-7.5-7.5Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 26c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5c-.3217 0-.6268.066-.9093.1766l-4.8837-4.8837-1.4141 1.4141 4.8837 4.8837c-.1107.2825-.1766.5876-.1766.9093 0 1.3807 1.1193 2.5 2.5 2.5zM29 13h-2v-3.4257l-11-6.4166-3 1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12 7c.3071.1792.4961.5081.4961.8638v4zM7 6H9V16H7z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "m13.9998,29.991l-10.5037-6.1272c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l10.0076,5.8378-1.0078,1.7275Z"
  })), children);
});
var IbmZEnvironmentsDevSecOps20 = /*#__PURE__*/React.forwardRef(function IbmZEnvironmentsDevSecOps20(_ref154, ref) {
  var children = _ref154.children,
      rest = _objectWithoutProperties(_ref154, _excluded154);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "m23.5,16v2c3.0327,0,5.5,2.4673,5.5,5.5s-2.4673,5.5-5.5,5.5-5.5-2.4673-5.5-5.5h-2c0,4.1422,3.3578,7.5,7.5,7.5s7.5-3.3578,7.5-7.5-3.3578-7.5-7.5-7.5Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 26c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5c-.3217 0-.6268.066-.9093.1766l-4.8837-4.8837-1.4141 1.4141 4.8837 4.8837c-.1107.2825-.1766.5876-.1766.9093 0 1.3807 1.1193 2.5 2.5 2.5zM29 13h-2v-3.4257l-11-6.4166-3 1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12 7c.3071.1792.4961.5081.4961.8638v4zM7 6H9V16H7z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "m13.9998,29.991l-10.5037-6.1272c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l10.0076,5.8378-1.0078,1.7275Z"
  })), children);
});
var IbmZEnvironmentsDevSecOps16 = /*#__PURE__*/React.forwardRef(function IbmZEnvironmentsDevSecOps16(_ref155, ref) {
  var children = _ref155.children,
      rest = _objectWithoutProperties(_ref155, _excluded155);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "m23.5,16v2c3.0327,0,5.5,2.4673,5.5,5.5s-2.4673,5.5-5.5,5.5-5.5-2.4673-5.5-5.5h-2c0,4.1422,3.3578,7.5,7.5,7.5s7.5-3.3578,7.5-7.5-3.3578-7.5-7.5-7.5Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 26c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5c-.3217 0-.6268.066-.9093.1766l-4.8837-4.8837-1.4141 1.4141 4.8837 4.8837c-.1107.2825-.1766.5876-.1766.9093 0 1.3807 1.1193 2.5 2.5 2.5zM29 13h-2v-3.4257l-11-6.4166-3 1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12 7c.3071.1792.4961.5081.4961.8638v4zM7 6H9V16H7z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "m13.9998,29.991l-10.5037-6.1272c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l10.0076,5.8378-1.0078,1.7275Z"
  })), children);
});
var IbmZProcessorCapacityReference32 = /*#__PURE__*/React.forwardRef(function IbmZProcessorCapacityReference32(_ref156, ref) {
  var children = _ref156.children,
      rest = _objectWithoutProperties(_ref156, _excluded156);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25H27V29H25zM21 23H23V29H21zM29 20H31V29H29z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17V5c0-1.1046-.8954-2-2-2h-9c-1.1046 0-2 .8954-2 2v24h2V5h9v12h2zM13 3H4c-1.1046 0-2 .8954-2 2v22c0 1.1046.8954 2 2 2h9c1.1046 0 2-.8954 2-2V5c0-1.1046-.8954-2-2-2zm-9 2.9635l8.2998 6.0365-8.2998 6.0365V5.9635zm0 21.0365v-5.0366l6.9253 5.0366h-6.9253zm9-.9635l-8.2998-6.0365 8.2998-6.0365v12.073zm0-15.9999l-6.9253-5.0366h6.9253v5.0366z"
  })), children);
});
var IbmZProcessorCapacityReference24 = /*#__PURE__*/React.forwardRef(function IbmZProcessorCapacityReference24(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, _excluded157);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25H27V29H25zM21 23H23V29H21zM29 20H31V29H29z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17V5c0-1.1046-.8954-2-2-2h-9c-1.1046 0-2 .8954-2 2v24h2V5h9v12h2zM13 3H4c-1.1046 0-2 .8954-2 2v22c0 1.1046.8954 2 2 2h9c1.1046 0 2-.8954 2-2V5c0-1.1046-.8954-2-2-2zm-9 2.9635l8.2998 6.0365-8.2998 6.0365V5.9635zm0 21.0365v-5.0366l6.9253 5.0366h-6.9253zm9-.9635l-8.2998-6.0365 8.2998-6.0365v12.073zm0-15.9999l-6.9253-5.0366h6.9253v5.0366z"
  })), children);
});
var IbmZProcessorCapacityReference20 = /*#__PURE__*/React.forwardRef(function IbmZProcessorCapacityReference20(_ref158, ref) {
  var children = _ref158.children,
      rest = _objectWithoutProperties(_ref158, _excluded158);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25H27V29H25zM21 23H23V29H21zM29 20H31V29H29z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17V5c0-1.1046-.8954-2-2-2h-9c-1.1046 0-2 .8954-2 2v24h2V5h9v12h2zM13 3H4c-1.1046 0-2 .8954-2 2v22c0 1.1046.8954 2 2 2h9c1.1046 0 2-.8954 2-2V5c0-1.1046-.8954-2-2-2zm-9 2.9635l8.2998 6.0365-8.2998 6.0365V5.9635zm0 21.0365v-5.0366l6.9253 5.0366h-6.9253zm9-.9635l-8.2998-6.0365 8.2998-6.0365v12.073zm0-15.9999l-6.9253-5.0366h6.9253v5.0366z"
  })), children);
});
var IbmZProcessorCapacityReference16 = /*#__PURE__*/React.forwardRef(function IbmZProcessorCapacityReference16(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, _excluded159);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25H27V29H25zM21 23H23V29H21zM29 20H31V29H29z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17V5c0-1.1046-.8954-2-2-2h-9c-1.1046 0-2 .8954-2 2v24h2V5h9v12h2zM13 3H4c-1.1046 0-2 .8954-2 2v22c0 1.1046.8954 2 2 2h9c1.1046 0 2-.8954 2-2V5c0-1.1046-.8954-2-2-2zm-9 2.9635l8.2998 6.0365-8.2998 6.0365V5.9635zm0 21.0365v-5.0366l6.9253 5.0366h-6.9253zm9-.9635l-8.2998-6.0365 8.2998-6.0365v12.073zm0-15.9999l-6.9253-5.0366h6.9253v5.0366z"
  })), children);
});
var IbmZCloudProvisioning32 = /*#__PURE__*/React.forwardRef(function IbmZCloudProvisioning32(_ref160, ref) {
  var children = _ref160.children,
      rest = _objectWithoutProperties(_ref160, _excluded160);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17H14V21H10zM17 10H21V14H17zM17 17H21V21H17z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
  })), children);
});
var IbmZCloudProvisioning24 = /*#__PURE__*/React.forwardRef(function IbmZCloudProvisioning24(_ref161, ref) {
  var children = _ref161.children,
      rest = _objectWithoutProperties(_ref161, _excluded161);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17H14V21H10zM17 10H21V14H17zM17 17H21V21H17z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
  })), children);
});
var IbmZCloudProvisioning20 = /*#__PURE__*/React.forwardRef(function IbmZCloudProvisioning20(_ref162, ref) {
  var children = _ref162.children,
      rest = _objectWithoutProperties(_ref162, _excluded162);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17H14V21H10zM17 10H21V14H17zM17 17H21V21H17z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
  })), children);
});
var IbmZCloudProvisioning16 = /*#__PURE__*/React.forwardRef(function IbmZCloudProvisioning16(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, _excluded163);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17H14V21H10zM17 10H21V14H17zM17 17H21V21H17z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
  })), children);
});
var IbmZOs32 = /*#__PURE__*/React.forwardRef(function IbmZOs32(_ref164, ref) {
  var children = _ref164.children,
      rest = _objectWithoutProperties(_ref164, _excluded164);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c-5.0793 0-9.7449-2.3319-12.7998-6.3979l1.5991-1.2014c2.6736 3.5585 6.7561 5.5994 11.2007 5.5994s8.5281-2.0413 11.2014-5.6005l1.5991 1.2012c-3.0547 4.0668-7.7202 6.3993-12.8005 6.3993zM30 22h-5v-2h5v-3h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h5v2h-5v3h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zM21 22h-4c-1.1028 0-2-.8972-2-2v-8c0-1.1028.8972-2 2-2h4c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-4-10v8h4v-8h-4zM11.4458 10L7.4458 22 9.5542 22 13.5542 10 11.4458 10zM6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22zM16.0001 0C10.9207 0 6.2552 2.3319 3.2003 6.3979l1.5991 1.2014c2.6736-3.5585 6.7561-5.5994 11.2007-5.5994s8.5281 2.0413 11.2014 5.6005l1.5991-1.2012C25.7459 2.3325 21.0804 0 16.0001 0z"
  })), children);
});
var IbmZOs24 = /*#__PURE__*/React.forwardRef(function IbmZOs24(_ref165, ref) {
  var children = _ref165.children,
      rest = _objectWithoutProperties(_ref165, _excluded165);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c-5.0793 0-9.7449-2.3319-12.7998-6.3979l1.5991-1.2014c2.6736 3.5585 6.7561 5.5994 11.2007 5.5994s8.5281-2.0413 11.2014-5.6005l1.5991 1.2012c-3.0547 4.0668-7.7202 6.3993-12.8005 6.3993zM30 22h-5v-2h5v-3h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h5v2h-5v3h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zM21 22h-4c-1.1028 0-2-.8972-2-2v-8c0-1.1028.8972-2 2-2h4c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-4-10v8h4v-8h-4zM11.4458 10L7.4458 22 9.5542 22 13.5542 10 11.4458 10zM6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22zM16.0001 0C10.9207 0 6.2552 2.3319 3.2003 6.3979l1.5991 1.2014c2.6736-3.5585 6.7561-5.5994 11.2007-5.5994s8.5281 2.0413 11.2014 5.6005l1.5991-1.2012C25.7459 2.3325 21.0804 0 16.0001 0z"
  })), children);
});
var IbmZOs20 = /*#__PURE__*/React.forwardRef(function IbmZOs20(_ref166, ref) {
  var children = _ref166.children,
      rest = _objectWithoutProperties(_ref166, _excluded166);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c-5.0793 0-9.7449-2.3319-12.7998-6.3979l1.5991-1.2014c2.6736 3.5585 6.7561 5.5994 11.2007 5.5994s8.5281-2.0413 11.2014-5.6005l1.5991 1.2012c-3.0547 4.0668-7.7202 6.3993-12.8005 6.3993zM30 22h-5v-2h5v-3h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h5v2h-5v3h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zM21 22h-4c-1.1028 0-2-.8972-2-2v-8c0-1.1028.8972-2 2-2h4c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-4-10v8h4v-8h-4zM11.4458 10L7.4458 22 9.5542 22 13.5542 10 11.4458 10zM6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22zM16.0001 0C10.9207 0 6.2552 2.3319 3.2003 6.3979l1.5991 1.2014c2.6736-3.5585 6.7561-5.5994 11.2007-5.5994s8.5281 2.0413 11.2014 5.6005l1.5991-1.2012C25.7459 2.3325 21.0804 0 16.0001 0z"
  })), children);
});
var IbmZOs16 = /*#__PURE__*/React.forwardRef(function IbmZOs16(_ref167, ref) {
  var children = _ref167.children,
      rest = _objectWithoutProperties(_ref167, _excluded167);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c-5.0793 0-9.7449-2.3319-12.7998-6.3979l1.5991-1.2014c2.6736 3.5585 6.7561 5.5994 11.2007 5.5994s8.5281-2.0413 11.2014-5.6005l1.5991 1.2012c-3.0547 4.0668-7.7202 6.3993-12.8005 6.3993zM30 22h-5v-2h5v-3h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h5v2h-5v3h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zM21 22h-4c-1.1028 0-2-.8972-2-2v-8c0-1.1028.8972-2 2-2h4c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-4-10v8h4v-8h-4zM11.4458 10L7.4458 22 9.5542 22 13.5542 10 11.4458 10zM6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22zM16.0001 0C10.9207 0 6.2552 2.3319 3.2003 6.3979l1.5991 1.2014c2.6736-3.5585 6.7561-5.5994 11.2007-5.5994s8.5281 2.0413 11.2014 5.6005l1.5991-1.2012C25.7459 2.3325 21.0804 0 16.0001 0z"
  })), children);
});
var IbmZOsAiControlInterface32 = /*#__PURE__*/React.forwardRef(function IbmZOsAiControlInterface32(_ref168, ref) {
  var children = _ref168.children,
      rest = _objectWithoutProperties(_ref168, _excluded168);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "21",
    r: "1"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "m23,25h-14c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h14c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-14-6v4h14v-4h-14Z"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "11",
    r: "1"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "m23,15h-14c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h14c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-14-6v4h14v-4h-14Z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "m28,30H4c-1.103,0-2-.897-2-2v-12h2v12h24V4h-12v-2h12c1.103,0,2,.897,2,2v24c0,1.103-.897,2-2,2Z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.5H13.5V3.5H8.5z",
    transform: "rotate(90 11 2.5)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M1.975 3.475H6.975V5.475H1.975z",
    transform: "rotate(45 4.475 4.475)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H5V12H0z"
  })), children);
});
var IbmZOsAiControlInterface24 = /*#__PURE__*/React.forwardRef(function IbmZOsAiControlInterface24(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, _excluded169);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "21",
    r: "1"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "m23,25h-14c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h14c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-14-6v4h14v-4h-14Z"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "11",
    r: "1"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "m23,15h-14c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h14c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-14-6v4h14v-4h-14Z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "m28,30H4c-1.103,0-2-.897-2-2v-12h2v12h24V4h-12v-2h12c1.103,0,2,.897,2,2v24c0,1.103-.897,2-2,2Z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.5H13.5V3.5H8.5z",
    transform: "rotate(90 11 2.5)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M1.975 3.475H6.975V5.475H1.975z",
    transform: "rotate(45 4.475 4.475)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H5V12H0z"
  })), children);
});
var IbmZOsAiControlInterface20 = /*#__PURE__*/React.forwardRef(function IbmZOsAiControlInterface20(_ref170, ref) {
  var children = _ref170.children,
      rest = _objectWithoutProperties(_ref170, _excluded170);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "21",
    r: "1"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "m23,25h-14c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h14c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-14-6v4h14v-4h-14Z"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "11",
    r: "1"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "m23,15h-14c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h14c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-14-6v4h14v-4h-14Z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "m28,30H4c-1.103,0-2-.897-2-2v-12h2v12h24V4h-12v-2h12c1.103,0,2,.897,2,2v24c0,1.103-.897,2-2,2Z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.5H13.5V3.5H8.5z",
    transform: "rotate(90 11 2.5)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M1.975 3.475H6.975V5.475H1.975z",
    transform: "rotate(45 4.475 4.475)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H5V12H0z"
  })), children);
});
var IbmZOsAiControlInterface16 = /*#__PURE__*/React.forwardRef(function IbmZOsAiControlInterface16(_ref171, ref) {
  var children = _ref171.children,
      rest = _objectWithoutProperties(_ref171, _excluded171);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "21",
    r: "1"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "m23,25h-14c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h14c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-14-6v4h14v-4h-14Z"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "11",
    r: "1"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "m23,15h-14c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h14c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-14-6v4h14v-4h-14Z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "m28,30H4c-1.103,0-2-.897-2-2v-12h2v12h24V4h-12v-2h12c1.103,0,2,.897,2,2v24c0,1.103-.897,2-2,2Z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.5H13.5V3.5H8.5z",
    transform: "rotate(90 11 2.5)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M1.975 3.475H6.975V5.475H1.975z",
    transform: "rotate(45 4.475 4.475)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H5V12H0z"
  })), children);
});
var IbmZOsContainers32 = /*#__PURE__*/React.forwardRef(function IbmZOsContainers32(_ref172, ref) {
  var children = _ref172.children,
      rest = _objectWithoutProperties(_ref172, _excluded172);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "m29,12h-9V3h9v9Zm-7-2h5v-5h-5v5Z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "m20,15v2h7v10h-10V3H5c-1.1028,0-2,.8975-2,2v22c0,1.1025.8972,2,2,2h22c1.1028,0,2-.8975,2-2v-12h-9Zm-13.5859,2h8.5859v8.5859l-8.5859-8.5859Zm8.5859-2H6.4141L15,6.4141v8.5859Zm-1.4141-10L5,13.5859V5h8.5859Zm-8.5859,13.4141l8.5859,8.5859H5v-8.5859Z"
  })), children);
});
var IbmZOsContainers24 = /*#__PURE__*/React.forwardRef(function IbmZOsContainers24(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, _excluded173);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "m29,12h-9V3h9v9Zm-7-2h5v-5h-5v5Z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "m20,15v2h7v10h-10V3H5c-1.1028,0-2,.8975-2,2v22c0,1.1025.8972,2,2,2h22c1.1028,0,2-.8975,2-2v-12h-9Zm-13.5859,2h8.5859v8.5859l-8.5859-8.5859Zm8.5859-2H6.4141L15,6.4141v8.5859Zm-1.4141-10L5,13.5859V5h8.5859Zm-8.5859,13.4141l8.5859,8.5859H5v-8.5859Z"
  })), children);
});
var IbmZOsContainers20 = /*#__PURE__*/React.forwardRef(function IbmZOsContainers20(_ref174, ref) {
  var children = _ref174.children,
      rest = _objectWithoutProperties(_ref174, _excluded174);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "m29,12h-9V3h9v9Zm-7-2h5v-5h-5v5Z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "m20,15v2h7v10h-10V3H5c-1.1028,0-2,.8975-2,2v22c0,1.1025.8972,2,2,2h22c1.1028,0,2-.8975,2-2v-12h-9Zm-13.5859,2h8.5859v8.5859l-8.5859-8.5859Zm8.5859-2H6.4141L15,6.4141v8.5859Zm-1.4141-10L5,13.5859V5h8.5859Zm-8.5859,13.4141l8.5859,8.5859H5v-8.5859Z"
  })), children);
});
var IbmZOsContainers16 = /*#__PURE__*/React.forwardRef(function IbmZOsContainers16(_ref175, ref) {
  var children = _ref175.children,
      rest = _objectWithoutProperties(_ref175, _excluded175);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "m29,12h-9V3h9v9Zm-7-2h5v-5h-5v5Z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "m20,15v2h7v10h-10V3H5c-1.1028,0-2,.8975-2,2v22c0,1.1025.8972,2,2,2h22c1.1028,0,2-.8975,2-2v-12h-9Zm-13.5859,2h8.5859v8.5859l-8.5859-8.5859Zm8.5859-2H6.4141L15,6.4141v8.5859Zm-1.4141-10L5,13.5859V5h8.5859Zm-8.5859,13.4141l8.5859,8.5859H5v-8.5859Z"
  })), children);
});
var IbmZOsPackageManager32 = /*#__PURE__*/React.forwardRef(function IbmZOsPackageManager32(_ref176, ref) {
  var children = _ref176.children,
      rest = _objectWithoutProperties(_ref176, _excluded176);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9v10.172l-2.586-2.586L11 18l5 5 5-5-1.414-1.414L17 19.172V9H15zM19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
  })), children);
});
var IbmZOsPackageManager24 = /*#__PURE__*/React.forwardRef(function IbmZOsPackageManager24(_ref177, ref) {
  var children = _ref177.children,
      rest = _objectWithoutProperties(_ref177, _excluded177);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9v10.172l-2.586-2.586L11 18l5 5 5-5-1.414-1.414L17 19.172V9H15zM19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
  })), children);
});
var IbmZOsPackageManager20 = /*#__PURE__*/React.forwardRef(function IbmZOsPackageManager20(_ref178, ref) {
  var children = _ref178.children,
      rest = _objectWithoutProperties(_ref178, _excluded178);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9v10.172l-2.586-2.586L11 18l5 5 5-5-1.414-1.414L17 19.172V9H15zM19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
  })), children);
});
var IbmZOsPackageManager16 = /*#__PURE__*/React.forwardRef(function IbmZOsPackageManager16(_ref179, ref) {
  var children = _ref179.children,
      rest = _objectWithoutProperties(_ref179, _excluded179);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9v10.172l-2.586-2.586L11 18l5 5 5-5-1.414-1.414L17 19.172V9H15zM19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
  })), children);
});
var WatsonHealthICa_2D32 = /*#__PURE__*/React.forwardRef(function WatsonHealthICa_2D32(_ref180, ref) {
  var children = _ref180.children,
      rest = _objectWithoutProperties(_ref180, _excluded180);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0122 24zM10 10V22H22V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
  })), children);
});
var WatsonHealthICa_2D24 = /*#__PURE__*/React.forwardRef(function WatsonHealthICa_2D24(_ref181, ref) {
  var children = _ref181.children,
      rest = _objectWithoutProperties(_ref181, _excluded181);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0122 24zM10 10V22H22V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
  })), children);
});
var WatsonHealthICa_2D20 = /*#__PURE__*/React.forwardRef(function WatsonHealthICa_2D20(_ref182, ref) {
  var children = _ref182.children,
      rest = _objectWithoutProperties(_ref182, _excluded182);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0122 24zM10 10V22H22V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
  })), children);
});
var WatsonHealthICa_2D16 = /*#__PURE__*/React.forwardRef(function WatsonHealthICa_2D16(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, _excluded183);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0122 24zM10 10V22H22V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
  })), children);
});
var IceAccretion32 = /*#__PURE__*/React.forwardRef(function IceAccretion32(_ref184, ref) {
  var children = _ref184.children,
      rest = _objectWithoutProperties(_ref184, _excluded184);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
  })), children);
});
var IceAccretion24 = /*#__PURE__*/React.forwardRef(function IceAccretion24(_ref185, ref) {
  var children = _ref185.children,
      rest = _objectWithoutProperties(_ref185, _excluded185);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
  })), children);
});
var IceAccretion20 = /*#__PURE__*/React.forwardRef(function IceAccretion20(_ref186, ref) {
  var children = _ref186.children,
      rest = _objectWithoutProperties(_ref186, _excluded186);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
  })), children);
});
var IceAccretion16 = /*#__PURE__*/React.forwardRef(function IceAccretion16(_ref187, ref) {
  var children = _ref187.children,
      rest = _objectWithoutProperties(_ref187, _excluded187);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
  })), children);
});
var IceVision32 = /*#__PURE__*/React.forwardRef(function IceVision32(_ref188, ref) {
  var children = _ref188.children,
      rest = _objectWithoutProperties(_ref188, _excluded188);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14L19 21 20 23 21 21 21 14 19 14zM17 14H13a2 2 0 00-2 2v4l1 2 1-2V16h2v7l1 2 1-2z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), children);
});
var IceVision24 = /*#__PURE__*/React.forwardRef(function IceVision24(_ref189, ref) {
  var children = _ref189.children,
      rest = _objectWithoutProperties(_ref189, _excluded189);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14L19 21 20 23 21 21 21 14 19 14zM17 14H13a2 2 0 00-2 2v4l1 2 1-2V16h2v7l1 2 1-2z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), children);
});
var IceVision20 = /*#__PURE__*/React.forwardRef(function IceVision20(_ref190, ref) {
  var children = _ref190.children,
      rest = _objectWithoutProperties(_ref190, _excluded190);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14L19 21 20 23 21 21 21 14 19 14zM17 14H13a2 2 0 00-2 2v4l1 2 1-2V16h2v7l1 2 1-2z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), children);
});
var IceVision16 = /*#__PURE__*/React.forwardRef(function IceVision16(_ref191, ref) {
  var children = _ref191.children,
      rest = _objectWithoutProperties(_ref191, _excluded191);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14L19 21 20 23 21 21 21 14 19 14zM17 14H13a2 2 0 00-2 2v4l1 2 1-2V16h2v7l1 2 1-2z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), children);
});
var QID32 = /*#__PURE__*/React.forwardRef(function QID32(_ref192, ref) {
  var children = _ref192.children,
      rest = _objectWithoutProperties(_ref192, _excluded192);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
  })), children);
});
var QID24 = /*#__PURE__*/React.forwardRef(function QID24(_ref193, ref) {
  var children = _ref193.children,
      rest = _objectWithoutProperties(_ref193, _excluded193);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
  })), children);
});
var QID20 = /*#__PURE__*/React.forwardRef(function QID20(_ref194, ref) {
  var children = _ref194.children,
      rest = _objectWithoutProperties(_ref194, _excluded194);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
  })), children);
});
var QID16 = /*#__PURE__*/React.forwardRef(function QID16(_ref195, ref) {
  var children = _ref195.children,
      rest = _objectWithoutProperties(_ref195, _excluded195);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
  })), children);
});
var IdManagement32 = /*#__PURE__*/React.forwardRef(function IdManagement32(_ref196, ref) {
  var children = _ref196.children,
      rest = _objectWithoutProperties(_ref196, _excluded196);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H9a3 3 0 00-3 3v2H8V23a1 1 0 011-1h6a1 1 0 011 1v2h2V23A3 3 0 0015 20zM12 19a4 4 0 10-4-4A4 4 0 0012 19zm0-6a2 2 0 11-2 2A2 2 0 0112 13z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19H26V21H20zM22 23H26V25H22zM32 10V8H29.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0026 4.1011V2H24V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0020.1011 8H18v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0024 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0029.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0125 12z"
  })), children);
});
var IdManagement24 = /*#__PURE__*/React.forwardRef(function IdManagement24(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, _excluded197);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H9a3 3 0 00-3 3v2H8V23a1 1 0 011-1h6a1 1 0 011 1v2h2V23A3 3 0 0015 20zM12 19a4 4 0 10-4-4A4 4 0 0012 19zm0-6a2 2 0 11-2 2A2 2 0 0112 13z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19H26V21H20zM22 23H26V25H22zM32 10V8H29.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0026 4.1011V2H24V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0020.1011 8H18v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0024 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0029.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0125 12z"
  })), children);
});
var IdManagement20 = /*#__PURE__*/React.forwardRef(function IdManagement20(_ref198, ref) {
  var children = _ref198.children,
      rest = _objectWithoutProperties(_ref198, _excluded198);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H9a3 3 0 00-3 3v2H8V23a1 1 0 011-1h6a1 1 0 011 1v2h2V23A3 3 0 0015 20zM12 19a4 4 0 10-4-4A4 4 0 0012 19zm0-6a2 2 0 11-2 2A2 2 0 0112 13z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19H26V21H20zM22 23H26V25H22zM32 10V8H29.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0026 4.1011V2H24V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0020.1011 8H18v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0024 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0029.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0125 12z"
  })), children);
});
var IdManagement16 = /*#__PURE__*/React.forwardRef(function IdManagement16(_ref199, ref) {
  var children = _ref199.children,
      rest = _objectWithoutProperties(_ref199, _excluded199);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H9a3 3 0 00-3 3v2H8V23a1 1 0 011-1h6a1 1 0 011 1v2h2V23A3 3 0 0015 20zM12 19a4 4 0 10-4-4A4 4 0 0012 19zm0-6a2 2 0 11-2 2A2 2 0 0112 13z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19H26V21H20zM22 23H26V25H22zM32 10V8H29.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0026 4.1011V2H24V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0020.1011 8H18v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0024 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0029.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0125 12z"
  })), children);
});
var Idea32 = /*#__PURE__*/React.forwardRef(function Idea32(_ref200, ref) {
  var children = _ref200.children,
      rest = _objectWithoutProperties(_ref200, _excluded200);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
  })), children);
});
var Idea24 = /*#__PURE__*/React.forwardRef(function Idea24(_ref201, ref) {
  var children = _ref201.children,
      rest = _objectWithoutProperties(_ref201, _excluded201);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
  })), children);
});
var Idea20 = /*#__PURE__*/React.forwardRef(function Idea20(_ref202, ref) {
  var children = _ref202.children,
      rest = _objectWithoutProperties(_ref202, _excluded202);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
  })), children);
});
var Idea16 = /*#__PURE__*/React.forwardRef(function Idea16(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, _excluded203);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
  })), children);
});
var Identification32 = /*#__PURE__*/React.forwardRef(function Identification32(_ref204, ref) {
  var children = _ref204.children,
      rest = _objectWithoutProperties(_ref204, _excluded204);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
  })), children);
});
var Identification24 = /*#__PURE__*/React.forwardRef(function Identification24(_ref205, ref) {
  var children = _ref205.children,
      rest = _objectWithoutProperties(_ref205, _excluded205);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
  })), children);
});
var Identification20 = /*#__PURE__*/React.forwardRef(function Identification20(_ref206, ref) {
  var children = _ref206.children,
      rest = _objectWithoutProperties(_ref206, _excluded206);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
  })), children);
});
var Identification16 = /*#__PURE__*/React.forwardRef(function Identification16(_ref207, ref) {
  var children = _ref207.children,
      rest = _objectWithoutProperties(_ref207, _excluded207);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
  })), children);
});
var Image32 = /*#__PURE__*/React.forwardRef(function Image32(_ref208, ref) {
  var children = _ref208.children,
      rest = _objectWithoutProperties(_ref208, _excluded208);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
  })), children);
});
var Image24 = /*#__PURE__*/React.forwardRef(function Image24(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, _excluded209);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
  })), children);
});
var Image20 = /*#__PURE__*/React.forwardRef(function Image20(_ref210, ref) {
  var children = _ref210.children,
      rest = _objectWithoutProperties(_ref210, _excluded210);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
  })), children);
});
var Image16 = /*#__PURE__*/React.forwardRef(function Image16(_ref211, ref) {
  var children = _ref211.children,
      rest = _objectWithoutProperties(_ref211, _excluded211);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
  })), children);
});
var ImageCopy32 = /*#__PURE__*/React.forwardRef(function ImageCopy32(_ref212, ref) {
  var children = _ref212.children,
      rest = _objectWithoutProperties(_ref212, _excluded212);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22H2V4A2.0023 2.0023 0 014 2H22V4H4zM21 17a3 3 0 10-3-3A3.0033 3.0033 0 0021 17zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0121 13z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z"
  })), children);
});
var ImageCopy24 = /*#__PURE__*/React.forwardRef(function ImageCopy24(_ref213, ref) {
  var children = _ref213.children,
      rest = _objectWithoutProperties(_ref213, _excluded213);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22H2V4A2.0023 2.0023 0 014 2H22V4H4zM21 17a3 3 0 10-3-3A3.0033 3.0033 0 0021 17zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0121 13z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z"
  })), children);
});
var ImageCopy20 = /*#__PURE__*/React.forwardRef(function ImageCopy20(_ref214, ref) {
  var children = _ref214.children,
      rest = _objectWithoutProperties(_ref214, _excluded214);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22H2V4A2.0023 2.0023 0 014 2H22V4H4zM21 17a3 3 0 10-3-3A3.0033 3.0033 0 0021 17zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0121 13z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z"
  })), children);
});
var ImageCopy16 = /*#__PURE__*/React.forwardRef(function ImageCopy16(_ref215, ref) {
  var children = _ref215.children,
      rest = _objectWithoutProperties(_ref215, _excluded215);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22H2V4A2.0023 2.0023 0 014 2H22V4H4zM21 17a3 3 0 10-3-3A3.0033 3.0033 0 0021 17zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0121 13z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z"
  })), children);
});
var ImageMedical32 = /*#__PURE__*/React.forwardRef(function ImageMedical32(_ref216, ref) {
  var children = _ref216.children,
      rest = _objectWithoutProperties(_ref216, _excluded216);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
  })), children);
});
var ImageMedical24 = /*#__PURE__*/React.forwardRef(function ImageMedical24(_ref217, ref) {
  var children = _ref217.children,
      rest = _objectWithoutProperties(_ref217, _excluded217);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
  })), children);
});
var ImageMedical20 = /*#__PURE__*/React.forwardRef(function ImageMedical20(_ref218, ref) {
  var children = _ref218.children,
      rest = _objectWithoutProperties(_ref218, _excluded218);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
  })), children);
});
var ImageMedical16 = /*#__PURE__*/React.forwardRef(function ImageMedical16(_ref219, ref) {
  var children = _ref219.children,
      rest = _objectWithoutProperties(_ref219, _excluded219);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
  })), children);
});
var ImageReference32 = /*#__PURE__*/React.forwardRef(function ImageReference32(_ref220, ref) {
  var children = _ref220.children,
      rest = _objectWithoutProperties(_ref220, _excluded220);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
  })), children);
});
var ImageReference24 = /*#__PURE__*/React.forwardRef(function ImageReference24(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, _excluded221);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
  })), children);
});
var ImageReference20 = /*#__PURE__*/React.forwardRef(function ImageReference20(_ref222, ref) {
  var children = _ref222.children,
      rest = _objectWithoutProperties(_ref222, _excluded222);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
  })), children);
});
var ImageReference16 = /*#__PURE__*/React.forwardRef(function ImageReference16(_ref223, ref) {
  var children = _ref223.children,
      rest = _objectWithoutProperties(_ref223, _excluded223);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
  })), children);
});
var ImageSearch32 = /*#__PURE__*/React.forwardRef(function ImageSearch32(_ref224, ref) {
  var children = _ref224.children,
      rest = _objectWithoutProperties(_ref224, _excluded224);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
  })), children);
});
var ImageSearch24 = /*#__PURE__*/React.forwardRef(function ImageSearch24(_ref225, ref) {
  var children = _ref225.children,
      rest = _objectWithoutProperties(_ref225, _excluded225);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
  })), children);
});
var ImageSearch20 = /*#__PURE__*/React.forwardRef(function ImageSearch20(_ref226, ref) {
  var children = _ref226.children,
      rest = _objectWithoutProperties(_ref226, _excluded226);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
  })), children);
});
var ImageSearch16 = /*#__PURE__*/React.forwardRef(function ImageSearch16(_ref227, ref) {
  var children = _ref227.children,
      rest = _objectWithoutProperties(_ref227, _excluded227);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
  })), children);
});
var ImageSearchAlt32 = /*#__PURE__*/React.forwardRef(function ImageSearchAlt32(_ref228, ref) {
  var children = _ref228.children,
      rest = _objectWithoutProperties(_ref228, _excluded228);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z"
  })), children);
});
var ImageSearchAlt24 = /*#__PURE__*/React.forwardRef(function ImageSearchAlt24(_ref229, ref) {
  var children = _ref229.children,
      rest = _objectWithoutProperties(_ref229, _excluded229);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z"
  })), children);
});
var ImageSearchAlt20 = /*#__PURE__*/React.forwardRef(function ImageSearchAlt20(_ref230, ref) {
  var children = _ref230.children,
      rest = _objectWithoutProperties(_ref230, _excluded230);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z"
  })), children);
});
var ImageSearchAlt16 = /*#__PURE__*/React.forwardRef(function ImageSearchAlt16(_ref231, ref) {
  var children = _ref231.children,
      rest = _objectWithoutProperties(_ref231, _excluded231);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z"
  })), children);
});
var WatsonHealthImageAvailabilityLocal32 = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityLocal32(_ref232, ref) {
  var children = _ref232.children,
      rest = _objectWithoutProperties(_ref232, _excluded232);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), children);
});
var WatsonHealthImageAvailabilityLocal24 = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityLocal24(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, _excluded233);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), children);
});
var WatsonHealthImageAvailabilityLocal20 = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityLocal20(_ref234, ref) {
  var children = _ref234.children,
      rest = _objectWithoutProperties(_ref234, _excluded234);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), children);
});
var WatsonHealthImageAvailabilityLocal16 = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityLocal16(_ref235, ref) {
  var children = _ref235.children,
      rest = _objectWithoutProperties(_ref235, _excluded235);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), children);
});
var WatsonHealthImageAvailabilityRetrieving32 = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityRetrieving32(_ref236, ref) {
  var children = _ref236.children,
      rest = _objectWithoutProperties(_ref236, _excluded236);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13L11.4 11.6 15 15.2 15 2 17 2 17 15.2 20.6 11.6 22 13 16 19z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4\tC7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10\tc0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z"
  })), children);
});
var WatsonHealthImageAvailabilityRetrieving24 = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityRetrieving24(_ref237, ref) {
  var children = _ref237.children,
      rest = _objectWithoutProperties(_ref237, _excluded237);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13L11.4 11.6 15 15.2 15 2 17 2 17 15.2 20.6 11.6 22 13 16 19z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4\tC7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10\tc0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z"
  })), children);
});
var WatsonHealthImageAvailabilityRetrieving20 = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityRetrieving20(_ref238, ref) {
  var children = _ref238.children,
      rest = _objectWithoutProperties(_ref238, _excluded238);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13L11.4 11.6 15 15.2 15 2 17 2 17 15.2 20.6 11.6 22 13 16 19z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4\tC7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10\tc0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z"
  })), children);
});
var WatsonHealthImageAvailabilityRetrieving16 = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityRetrieving16(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, _excluded239);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13L11.4 11.6 15 15.2 15 2 17 2 17 15.2 20.6 11.6 22 13 16 19z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4\tC7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10\tc0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z"
  })), children);
});
var WatsonHealthImageAvailabilityUnavailable32 = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityUnavailable32(_ref240, ref) {
  var children = _ref240.children,
      rest = _objectWithoutProperties(_ref240, _excluded240);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "20.5",
    r: "1.5"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17\tz"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), children);
});
var WatsonHealthImageAvailabilityUnavailable24 = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityUnavailable24(_ref241, ref) {
  var children = _ref241.children,
      rest = _objectWithoutProperties(_ref241, _excluded241);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "20.5",
    r: "1.5"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17\tz"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), children);
});
var WatsonHealthImageAvailabilityUnavailable20 = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityUnavailable20(_ref242, ref) {
  var children = _ref242.children,
      rest = _objectWithoutProperties(_ref242, _excluded242);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "20.5",
    r: "1.5"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17\tz"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), children);
});
var WatsonHealthImageAvailabilityUnavailable16 = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityUnavailable16(_ref243, ref) {
  var children = _ref243.children,
      rest = _objectWithoutProperties(_ref243, _excluded243);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "20.5",
    r: "1.5"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17\tz"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0\tc0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13\tc0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), children);
});
var ImageService32 = /*#__PURE__*/React.forwardRef(function ImageService32(_ref244, ref) {
  var children = _ref244.children,
      rest = _objectWithoutProperties(_ref244, _excluded244);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4H15V12H13zM9 4H11V12H9zM21 12H19a2.0021 2.0021 0 01-2-2V6a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0121 12zM19 6v4h2V6zM21 14H23V22H21zM9 14H11V22H9zM17 22H15a2.0021 2.0021 0 01-2-2V16a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0117 22zm-2-6v4h2V16z"
  })), children);
});
var ImageService24 = /*#__PURE__*/React.forwardRef(function ImageService24(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, _excluded245);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4H15V12H13zM9 4H11V12H9zM21 12H19a2.0021 2.0021 0 01-2-2V6a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0121 12zM19 6v4h2V6zM21 14H23V22H21zM9 14H11V22H9zM17 22H15a2.0021 2.0021 0 01-2-2V16a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0117 22zm-2-6v4h2V16z"
  })), children);
});
var ImageService20 = /*#__PURE__*/React.forwardRef(function ImageService20(_ref246, ref) {
  var children = _ref246.children,
      rest = _objectWithoutProperties(_ref246, _excluded246);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4H15V12H13zM9 4H11V12H9zM21 12H19a2.0021 2.0021 0 01-2-2V6a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0121 12zM19 6v4h2V6zM21 14H23V22H21zM9 14H11V22H9zM17 22H15a2.0021 2.0021 0 01-2-2V16a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0117 22zm-2-6v4h2V16z"
  })), children);
});
var ImageService16 = /*#__PURE__*/React.forwardRef(function ImageService16(_ref247, ref) {
  var children = _ref247.children,
      rest = _objectWithoutProperties(_ref247, _excluded247);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4H15V12H13zM9 4H11V12H9zM21 12H19a2.0021 2.0021 0 01-2-2V6a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0121 12zM19 6v4h2V6zM21 14H23V22H21zM9 14H11V22H9zM17 22H15a2.0021 2.0021 0 01-2-2V16a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0117 22zm-2-6v4h2V16z"
  })), children);
});
var ImportExport32 = /*#__PURE__*/React.forwardRef(function ImportExport32(_ref248, ref) {
  var children = _ref248.children,
      rest = _objectWithoutProperties(_ref248, _excluded248);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24v4H4V24H2v4l.0076-.0049A1.9977 1.9977 0 004 30H28a2 2 0 002-2h0V24zM27.6 14.6L24 18.2 24 4 22 4 22 18.2 18.4 14.6 17 16 23 22 29 16 27.6 14.6zM9 4L3 10 4.4 11.4 8 7.8 8 22 10 22 10 7.8 13.6 11.4 15 10 9 4z"
  })), children);
});
var ImportExport24 = /*#__PURE__*/React.forwardRef(function ImportExport24(_ref249, ref) {
  var children = _ref249.children,
      rest = _objectWithoutProperties(_ref249, _excluded249);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24v4H4V24H2v4l.0076-.0049A1.9977 1.9977 0 004 30H28a2 2 0 002-2h0V24zM27.6 14.6L24 18.2 24 4 22 4 22 18.2 18.4 14.6 17 16 23 22 29 16 27.6 14.6zM9 4L3 10 4.4 11.4 8 7.8 8 22 10 22 10 7.8 13.6 11.4 15 10 9 4z"
  })), children);
});
var ImportExport20 = /*#__PURE__*/React.forwardRef(function ImportExport20(_ref250, ref) {
  var children = _ref250.children,
      rest = _objectWithoutProperties(_ref250, _excluded250);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24v4H4V24H2v4l.0076-.0049A1.9977 1.9977 0 004 30H28a2 2 0 002-2h0V24zM27.6 14.6L24 18.2 24 4 22 4 22 18.2 18.4 14.6 17 16 23 22 29 16 27.6 14.6zM9 4L3 10 4.4 11.4 8 7.8 8 22 10 22 10 7.8 13.6 11.4 15 10 9 4z"
  })), children);
});

export { IbmCloudPakApplications16, IbmCloudPakApplications20, IbmCloudPakApplications24, IbmCloudPakApplications32, IbmCloudPakBusinessAutomation16, IbmCloudPakBusinessAutomation20, IbmCloudPakBusinessAutomation24, IbmCloudPakBusinessAutomation32, IbmCloudPakData16, IbmCloudPakData20, IbmCloudPakData24, IbmCloudPakData32, IbmCloudPakIntegration16, IbmCloudPakIntegration20, IbmCloudPakIntegration24, IbmCloudPakIntegration32, IbmCloudPakMantaAutomatedDataLineage16, IbmCloudPakMantaAutomatedDataLineage20, IbmCloudPakMantaAutomatedDataLineage24, IbmCloudPakMantaAutomatedDataLineage32, IbmCloudPakMulticloudMgmt16, IbmCloudPakMulticloudMgmt20, IbmCloudPakMulticloudMgmt24, IbmCloudPakMulticloudMgmt32, IbmCloudPakNetezza16, IbmCloudPakNetezza20, IbmCloudPakNetezza24, IbmCloudPakNetezza32, IbmCloudPakNetworkAutomation16, IbmCloudPakNetworkAutomation20, IbmCloudPakNetworkAutomation24, IbmCloudPakNetworkAutomation32, IbmCloudPakSecurity16, IbmCloudPakSecurity20, IbmCloudPakSecurity24, IbmCloudPakSecurity32, IbmCloudPakSystem16, IbmCloudPakSystem20, IbmCloudPakSystem24, IbmCloudPakSystem32, IbmCloudPakWatsonAiops16, IbmCloudPakWatsonAiops20, IbmCloudPakWatsonAiops24, IbmCloudPakWatsonAiops32, IbmCloudVirtualServerClassic16, IbmCloudVirtualServerClassic20, IbmCloudVirtualServerClassic24, IbmCloudVirtualServerVpc16, IbmCloudVirtualServerVpc20, IbmCloudVirtualServerVpc24, IbmCloudVirtualServerVpc32, IbmCloudVpc16, IbmCloudVpc20, IbmCloudVpc24, IbmCloudVpc32, IbmCloudVpcEndpoints16, IbmCloudVpcEndpoints20, IbmCloudVpcEndpoints24, IbmCloudVpcEndpoints32, IbmSecurity16, IbmSecurity20, IbmSecurity24, IbmSecurity32, IbmSecurityServices16, IbmSecurityServices20, IbmSecurityServices24, IbmSecurityServices32, IbmWatsonAssistant16, IbmWatsonAssistant20, IbmWatsonAssistant24, IbmWatsonAssistant32, IbmWatsonDiscovery16, IbmWatsonDiscovery20, IbmWatsonDiscovery24, IbmWatsonDiscovery32, IbmWatsonKnowledgeCatalog16, IbmWatsonKnowledgeCatalog20, IbmWatsonKnowledgeCatalog24, IbmWatsonKnowledgeCatalog32, IbmWatsonKnowledgeStudio16, IbmWatsonKnowledgeStudio20, IbmWatsonKnowledgeStudio24, IbmWatsonKnowledgeStudio32, IbmWatsonLanguageTranslator16, IbmWatsonLanguageTranslator20, IbmWatsonLanguageTranslator24, IbmWatsonLanguageTranslator32, IbmWatsonMachineLearning16, IbmWatsonMachineLearning20, IbmWatsonMachineLearning24, IbmWatsonMachineLearning32, IbmWatsonNaturalLanguageClassifier16, IbmWatsonNaturalLanguageClassifier20, IbmWatsonNaturalLanguageClassifier24, IbmWatsonNaturalLanguageClassifier32, IbmWatsonNaturalLanguageUnderstanding16, IbmWatsonNaturalLanguageUnderstanding20, IbmWatsonNaturalLanguageUnderstanding24, IbmWatsonNaturalLanguageUnderstanding32, IbmWatsonOpenscale16, IbmWatsonOpenscale20, IbmWatsonOpenscale24, IbmWatsonOpenscale32, IbmWatsonOrders16, IbmWatsonOrders20, IbmWatsonOrders24, IbmWatsonOrders32, IbmWatsonQuery16, IbmWatsonQuery20, IbmWatsonQuery24, IbmWatsonQuery32, IbmWatsonSpeechToText16, IbmWatsonSpeechToText20, IbmWatsonSpeechToText24, IbmWatsonSpeechToText32, IbmWatsonStudio16, IbmWatsonStudio20, IbmWatsonStudio24, IbmWatsonStudio32, IbmWatsonTextToSpeech16, IbmWatsonTextToSpeech20, IbmWatsonTextToSpeech24, IbmWatsonTextToSpeech32, IbmWatsonToneAnalyzer16, IbmWatsonToneAnalyzer20, IbmWatsonToneAnalyzer24, IbmWatsonToneAnalyzer32, IbmWatsonxAssistant16, IbmWatsonxAssistant20, IbmWatsonxAssistant24, IbmWatsonxAssistant32, IbmWatsonxCodeAssistant16, IbmWatsonxCodeAssistant20, IbmWatsonxCodeAssistant24, IbmWatsonxCodeAssistant32, IbmWatsonxCodeAssistantForZ16, IbmWatsonxCodeAssistantForZ20, IbmWatsonxCodeAssistantForZ24, IbmWatsonxCodeAssistantForZ32, IbmWatsonxCodeAssistantForZRefactor16, IbmWatsonxCodeAssistantForZRefactor20, IbmWatsonxCodeAssistantForZRefactor24, IbmWatsonxCodeAssistantForZRefactor32, IbmWatsonxOrchestrate16, IbmWatsonxOrchestrate20, IbmWatsonxOrchestrate24, IbmWatsonxOrchestrate32, IbmZCloudModStack16, IbmZCloudModStack20, IbmZCloudModStack24, IbmZCloudModStack32, IbmZCloudProvisioning16, IbmZCloudProvisioning20, IbmZCloudProvisioning24, IbmZCloudProvisioning32, IbmZEnvironmentsDevSecOps16, IbmZEnvironmentsDevSecOps20, IbmZEnvironmentsDevSecOps24, IbmZEnvironmentsDevSecOps32, IbmZOs16, IbmZOs20, IbmZOs24, IbmZOs32, IbmZOsAiControlInterface16, IbmZOsAiControlInterface20, IbmZOsAiControlInterface24, IbmZOsAiControlInterface32, IbmZOsContainers16, IbmZOsContainers20, IbmZOsContainers24, IbmZOsContainers32, IbmZOsPackageManager16, IbmZOsPackageManager20, IbmZOsPackageManager24, IbmZOsPackageManager32, IbmZProcessorCapacityReference16, IbmZProcessorCapacityReference20, IbmZProcessorCapacityReference24, IbmZProcessorCapacityReference32, IceAccretion16, IceAccretion20, IceAccretion24, IceAccretion32, IceVision16, IceVision20, IceVision24, IceVision32, IdManagement16, IdManagement20, IdManagement24, IdManagement32, Idea16, Idea20, Idea24, Idea32, Identification16, Identification20, Identification24, Identification32, Image16, Image20, Image24, Image32, ImageCopy16, ImageCopy20, ImageCopy24, ImageCopy32, ImageMedical16, ImageMedical20, ImageMedical24, ImageMedical32, ImageReference16, ImageReference20, ImageReference24, ImageReference32, ImageSearch16, ImageSearch20, ImageSearch24, ImageSearch32, ImageSearchAlt16, ImageSearchAlt20, ImageSearchAlt24, ImageSearchAlt32, ImageService16, ImageService20, ImageService24, ImageService32, ImportExport20, ImportExport24, ImportExport32, QID16, QID20, QID24, QID32, WatsonHealthICa_2D16, WatsonHealthICa_2D20, WatsonHealthICa_2D24, WatsonHealthICa_2D32, WatsonHealthImageAvailabilityLocal16, WatsonHealthImageAvailabilityLocal20, WatsonHealthImageAvailabilityLocal24, WatsonHealthImageAvailabilityLocal32, WatsonHealthImageAvailabilityRetrieving16, WatsonHealthImageAvailabilityRetrieving20, WatsonHealthImageAvailabilityRetrieving24, WatsonHealthImageAvailabilityRetrieving32, WatsonHealthImageAvailabilityUnavailable16, WatsonHealthImageAvailabilityUnavailable20, WatsonHealthImageAvailabilityUnavailable24, WatsonHealthImageAvailabilityUnavailable32 };
